import React, { useEffect, useMemo, useRef, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios';
import { BASE_URL3 } from '../../config/axios';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import '../project/css/project.css';
import { useNavigate } from 'react-router-dom';
import { CSSForSelect, CSSForSelectModern, handleErrorToast } from '../../components/CustomFunctions';
import { AddwithWhiteCircle, CrosswithWITECircle, DeleteDustbin, SearchBig, UpdatePencil } from '../../components/AllSvg';
import {
  Info, Briefcase, Table2, ReceiptText, FileText, Calendar, Building2,
  ChevronRight, AlertCircle, Check, X, Save, Loader, Plus, Trash2, MinusCircle,
  SectionIcon,
  Eye,
  Search,
  Landmark,
  UserRound
} from 'lucide-react';
import { QuotationManagement } from './QuatationCRUD';
import { AddModalButton, DeleteModalButton, UpdateModalButton } from '../../components/DynamicButtons';
// SectionIcon aur CSSForSelectModern jahan AddProjectDetails mein import kiye hain, wahin se yahan bhi lo

// const AddQuatatations = ({ getNotes, worktypeName, getData }) => {
//   const [formData, setFormData] = useState({
//     ref_no: "",
//     date: null,
//     data: [{
//       description: "",
//     }],
//     to: "",
//     subject: "",
//     project_details: "",
//     worktype: [{
//       id: "",
//       name: "",
//     }],
//     note_ids: [],
//     client_ids: [],
//     notes: [],
//     rate: [{
//       description: ``,
//       amount: ``,
//     }],
//     workstages: [{
//       workStages: "",
//       percentage: "",
//     }],

//     termsandconditions: [{
//       item: ""
//     }],

//     structured_field: [
//       {
//         usedfor: "",
//         total: "",
//         work_type_rate: "",
//         Data: [
//           {
//             heading: "",
//             Data: [{
//               item: "",
//             }]
//           }
//         ]
//       }
//     ],

//     subcompany_id: "85bc33a1-3a08-4f72-bedc-a3710d246239",

//   });


//   console.log("formData")





//   const [subcompany, setSubCompany] = useState([])
//   const getSubCompany = async () => {

//     try {
//       const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
//       setSubCompany(res.data);
//     } catch (err) {
//       handleErrorToast(err)
//     } finally {
//     }
//   };

//   useEffect(() => {
//     getSubCompany();
//   }, [])

//   const company_name = sessionStorage.getItem('sub_company_name');
//   const subcompanyId = subcompany.filter(i => i.title === company_name);

//   console.log("company_name", company_name);
//   console.log("subcompanyId", subcompanyId);


//   const company_id = subcompanyId.length > 0 ? subcompanyId[0].id : null;
//   const companyids = sessionStorage.getItem('sub_company_id');

//   console.log("company_id", company_id);

//   const [clientData, setClientData] = useState([]);


//   const getClientData = async () => {

//     try {
//       const res = await axios.get(`${BASE_URL3}/project/clientbysubcompany/${companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? 'null' : '85bc33a1-3a08-4f72-bedc-a3710d246239'}/`);

//       if (companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d") {
//         setClientData(res.data.filter(i => i.sub_company !== "85bc33a1-3a08-4f72-bedc-a3710d246239"))

//       }
//       else {
//         setClientData(res.data)

//       }
//     } catch (err) {
//       //toast Logic
//       if (err.response) {
//         const errorData = err.response.data;

//         if (typeof errorData.error === 'string') {
//           // Single error message
//           toast.error(`Error: ${errorData.error}`);
//         } else if (typeof errorData === 'object' && errorData !== null) {
//           // Multiple error messages
//           Object.entries(errorData).forEach(([field, messages]) => {
//             messages.forEach(message => toast.error(`"${field}": ${message}`));
//           });
//         } else {
//           toast.error('Error:- Failed to Process!');
//         }
//       } else {
//         toast.error('Error processing your request.');
//       }
//     } finally {
//     }
//   }
//   useEffect(() => {

//     getClientData();
//   }, [company_id]);



//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const [show, setShow] = useState(false);

//   const handleShow = () => {

//     setShow(true);
//     getCompany();
//   }

//   const handleClose = () => {
//     setShow(false);

//     setFormData({
//       ref_no: "",
//       date: null,
//       data: [{
//         description: "",
//       }],
//       to: "",
//       subject: "",
//       project_details: "",
//       worktype: [{
//         id: "",
//         name: "",
//       }],
//       note_ids: [],
//       client_ids: [],
//       notes: [],
//       rate: [{
//         description: ``,
//         amount: ``,
//       }],
//       workstages: [{
//         workStages: "",
//         percentage: "",
//       }],

//       termsandconditions: [{
//         item: ""
//       }],

//       structured_field: [
//         {
//           usedfor: "",
//           total: "",
//           work_type_rate: "",
//           Data: [
//             {
//               heading: "",
//               Data: [{
//                 item: "",
//               }]
//             }
//           ]
//         }
//       ],

//       subcompany_id: "85bc33a1-3a08-4f72-bedc-a3710d246239",
//     })
//     setErrors({

//     });
//   }

//   const [searchTerm, setSearchTerm] = useState("");

//   const ClientListData = (clientData || [])
//     .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
//     .sort((a, b) => a.title.localeCompare(b.title))
//     .map((i, index) => ({
//       value: i.id,
//       label: `${index + 1}. ${i.title}`,
//     }));

//   const handleClientChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         to: "",
//       });
//     } else {
//       setFormData({
//         ...formData,
//         to: selectedOption.value,
//       });
//     }
//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.project;
//       return updatedErrors;
//     });
//   };
//   const workTypeDatra = (worktypeName || [])
//     .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
//     .sort((a, b) => a.title.localeCompare(b.title))
//     .map((i, index) => ({
//       value: i.id,
//       label: `${index + 1}. ${i.title}`,
//     }));

//   const handleWorkTypeChange = (selectedOptions) => {
//     if (!selectedOptions) {
//       setFormData({
//         ...formData,
//         worktype: [],
//       });
//     } else {
//       setFormData({
//         ...formData,
//         worktype: selectedOptions.map(option => ({
//           id: option.value,
//           name: option.label.replace(/^\d+\.\s/, '')
//         })),
//       });
//     }

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.worktype_id;
//       return updatedErrors;
//     });
//   };


//   useEffect(() => {
//     setFormData(prev => {
//       if (!prev.termsandconditions || prev.termsandconditions.length === 0) return prev;

//       const workstages = prev.termsandconditions.map(tc => {
//         const match = tc.item.match(/^(\d+)%\s*(.*)$/);
//         return {
//           percentage: match ? parseFloat(match[1]) : 0,
//           workStages: match ? match[2].trim() : ""
//         };
//       });

//       return { ...prev, workstages };
//     });
//   }, [formData.termsandconditions]);


//   console.log("formData")
//   console.log(formData)

//   useEffect(() => {
//     const filteredNotes = getNotes.filter(note =>
//       (formData.worktype || []).some(wt => wt.id === note.worktype?.id)
//     );


//     const notesId = filteredNotes.map((i) => (
//       i.id
//     ))

//     setFormData((prev) => ({
//       ...prev,
//       notes: filteredNotes,
//       note_ids: notesId

//     }));
//   }, [getNotes, formData.worktype]);

//   useEffect(() => {
//     if (!formData.worktype || formData.worktype.length === 0) {
//       return;
//     }

//     setFormData(prev => {
//       const newFields = formData.worktype.map(wt => {
//         const existing = prev.structured_field.find(sf => sf.usedfor === wt.name);
//         return existing || {
//           usedfor: wt.name,
//           Data: [
//             {
//               heading: "",
//               Data: [{ item: "" }]
//             }
//           ]
//         };
//       });

//       return {
//         ...prev,
//         structured_field: newFields
//       };
//     });
//   }, [formData.worktype]);








//   const addNewDescription = () => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       termsandconditions: [...prevFormData.termsandconditions, { item: "" }],
//     }));
//   };

//   const handleDescriptionChange = (index, value) => {
//     const updatedData = [...formData.termsandconditions];


//     if (!updatedData[index]) {
//       updatedData[index] = { item: "" };
//     }

//     updatedData[index].item = value;
//     setFormData({ ...formData, termsandconditions: updatedData });


//     if (value.trim()) {
//       setErrors((prevErrors) => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[`item_${index}`];
//         return updatedErrors;
//       });
//     }
//   };

//   const handleWorkTypeRateChange = (usedfor, value) => {
//     setFormData(prev => {
//       const structured_field = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           return { ...sf, worktype_rate: value };
//         }
//         return sf;
//       });

//       return { ...prev, structured_field };
//     });
//   };


//   const fileInputRefs = useRef([]);

//   const handleRemoveData = (index) => {
//     setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
//     fileInputRefs.current.splice(index, 1);
//   };


//   const [errors, setErrors] = useState({});

//   const [inputState, setInputState] = useState({});

//   const validateForm = () => {
//     const newErrors = {};

//     const requiredFields = [];
//     requiredFields.forEach((field) => {
//       if (!formData[field] || formData[field] === "null") {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });



//     setErrors(newErrors);
//     setIsSubmitted(true);

//     return Object.keys(newErrors).length === 0;
//   };



//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {

//       const loadingToastId = toast.loading("Loading: Please wait...");
//       setLoading(true);
//       try {
//         let res = await axios.post(`${BASE_URL3}/project/quotations/`, formData);

//         if (res.status === 200 || res.status === 201) {
//           getData();
//           handleClose();
//           toast.dismiss(loadingToastId);
//           toast.success("Quotation Added successfully!");

//         } else {
//           alert(res);
//         }
//       } catch (err) {
//         if (err.response) {
//           toast.dismiss(loadingToastId);
//           const errorData = err.response.data;

//           if (typeof errorData.error === 'string') {
//             toast.error(`Error: ${errorData.error}`);
//           } else if (typeof errorData === 'object' && errorData !== null) {
//             Object.entries(errorData).forEach(([field, messages]) => {
//               messages.forEach(message => toast.error(`"${field}": ${message}`));
//             });
//           } else {
//             toast.error('Error:- Failed to Process!');
//           }
//         } else {
//           toast.error('Error processing your request.');
//         }
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }

//     }
//   };
//   const [company, setCompany] = useState([]);

//   const getCompany = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
//       setCompany(res.data);
//     } catch (error) {
//       console.error(error);

//     }
//   }




//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: value,
//     });

//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     if (value.trim()) {
//       setErrors((prevErrors) => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[name];
//         return updatedErrors;
//       });
//     }
//   };


//   const removeDescription = (index) => {
//     const updatedData = formData.termsandconditions.filter((_, i) => i !== index);
//     setFormData({ ...formData, termsandconditions: updatedData });

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors[`item_${index}`];

//       const reorderedErrors = {};
//       Object.keys(updatedErrors).forEach((key) => {
//         if (key.startsWith("item_")) {
//           const idx = parseInt(key.split("_")[1], 10);
//           reorderedErrors[
//             `item_${idx > index ? idx - 1 : idx}`
//           ] = updatedErrors[key];
//         } else {
//           reorderedErrors[key] = updatedErrors[key];
//         }
//       });

//       return reorderedErrors;
//     });
//   };



//   const [expandedTables, setExpandedTables] = useState({});

//   const toggleTable = (usedfor) => {
//     setExpandedTables((prev) => {
//       const isOpen = prev[usedfor];

//       if (isOpen) {

//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           structured_field: prevFormData.structured_field.map((sf) =>
//             sf.usedfor === usedfor
//               ? {
//                 ...sf,
//                 Data: [
//                   {
//                     heading: "",
//                     Data: [{ item: "" }],
//                   },
//                 ],
//                 worktype_rate: "",
//                 total: 0,
//               }
//               : sf
//           ),
//         }));

//         return { ...prev, [usedfor]: false };
//       } else {

//         return { ...prev, [usedfor]: true };
//       }
//     });
//   };

























//   const addRateRow = () => {
//     setFormData((prev) => ({
//       ...prev,
//       rate: [...prev.rate, { description: "", amount: "" }],
//     }));
//   };


//   const removeRateRow = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       rate: prev.rate.filter((_, i) => i !== index),
//     }));
//   };


//   const handleRateChange = (index, field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       rate: prev.rate.map((item, i) =>
//         i === index ? { ...item, [field]: value } : item
//       ),
//     }));
//   };



//   const handleStructuredFieldChange = (usedfor, headingIndex, itemIndex, value) => {
//     setFormData(prev => {
//       const structured_field = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           const updatedData = sf.Data.map((headingObj, hIdx) => {
//             if (hIdx === headingIndex) {

//               const updatedItems = [...(headingObj.Data || [])];
//               while (updatedItems.length <= itemIndex) {
//                 updatedItems.push({ item: "" });
//               }
//               updatedItems[itemIndex] = { item: value };
//               return { ...headingObj, Data: updatedItems };
//             }
//             return headingObj;
//           });
//           return { ...sf, Data: updatedData };
//         }
//         return sf;
//       });
//       return { ...prev, structured_field };
//     });
//   };

//   useEffect(() => {
//     if (!formData.worktype || formData.worktype.length === 0) {
//       return;
//     }

//     setFormData(prev => {
//       const newFields = formData.worktype.map(wt => {
//         const existing = prev.structured_field.find(sf => sf.usedfor === wt.name);
//         return existing || {
//           usedfor: wt.name,
//           Data: [
//             {
//               heading: "",
//               Data: [{ item: "" }]
//             }
//           ]
//         };
//       });

//       return {
//         ...prev,
//         structured_field: newFields
//       };
//     });
//   }, [formData.worktype]);



//   const addNewHeading = (usedfor) => {
//     setFormData(prev => {
//       const updatedStructuredField = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           return {
//             ...sf,
//             Data: [...sf.Data, { heading: "", Data: [{ item: "" }] }]
//           };
//         }
//         return sf;
//       });

//       return {
//         ...prev,
//         structured_field: updatedStructuredField
//       };
//     });
//   };

//   const handleRemoveDescription = (noteIndex, descIndex) => {
//     setFormData((prev) => {
//       const updatedNotes = [...prev.notes];
//       updatedNotes[noteIndex].data = updatedNotes[noteIndex].data.filter(
//         (_, i) => i !== descIndex
//       );




//       return { ...prev, notes: updatedNotes };
//     });
//   };

//   const handleHeadingChange = (usedfor, headingIndex, value) => {
//     setFormData(prev => {
//       const updatedStructuredField = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           const updatedData = sf.Data.map((hdg, idx) => {
//             if (idx === headingIndex) {
//               return { ...hdg, heading: value };
//             }
//             return hdg;
//           });
//           return { ...sf, Data: updatedData };
//         }
//         return sf;
//       });

//       return { ...prev, structured_field: updatedStructuredField };
//     });
//   };

//   const generateRows = (structuredField) => {
//     const maxLength = Math.max(...structuredField.Data.map(h => h.Data.length));

//     const rows = Array.from({ length: maxLength }, (_, rowIndex) =>
//       structuredField.Data.map((headingObj) => {
//         return headingObj.Data[rowIndex] || { item: "" };
//       })
//     );

//     return rows;
//   };

//   const addNewItemToAllHeadings = (usedfor) => {
//     setFormData(prev => {
//       const updatedStructuredField = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           const updatedData = sf.Data.map((headingObj) => ({
//             ...headingObj,
//             Data: [...headingObj.Data, { item: "" }]
//           }));
//           return {
//             ...sf,
//             Data: updatedData
//           };
//         }
//         return sf;
//       });

//       return {
//         ...prev,
//         structured_field: updatedStructuredField
//       };
//     });
//   };

//   const handleRemoveRow = (usedfor, rowIndex) => {
//     setFormData(prev => {
//       const updated = { ...prev };
//       const section = updated.structured_field.find(sf => sf.usedfor === usedfor);

//       if (section && section.Data?.length > 0) {
//         section.Data.forEach(col => {
//           if (col?.Data && col.Data[rowIndex] !== undefined) {
//             col.Data.splice(rowIndex, 1);
//           }
//         });
//       }

//       return { ...updated };
//     });
//   };
//   const removeColumn = (usedfor, headingIndex) => {
//     setFormData((prev) => {
//       const updatedFields = prev.structured_field.map((field) => {
//         if (field.usedfor === usedfor) {

//           const newData = field.Data.filter((_, index) => index !== headingIndex);


//           const updatedData = newData.map((headingObj) => {
//             return {
//               ...headingObj,
//               Data: headingObj.Data.map((cellObj) => cellObj)
//             };
//           });

//           return { ...field, Data: updatedData };
//         }
//         return field;
//       });

//       return { ...prev, structured_field: updatedFields };
//     });
//   };



//   return (
//     <>
//       <button className='upload-svg' onClick={handleShow}>
//         <AddwithWhiteCircle /> {"Quotations"}
//       </button>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
//         <Modal.Header closeButton>
//           <Modal.Title>Add Quotation Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">

//             <div className='form-flex-wrap' style={{ justifyContent: "space-between" }}>

//               <div className="flex-column ">
//                 <label className="form-labels">Ref. Number:<span className="required">*</span></label>
//                 <input
//                   type="text"
//                   name="ref_no"
//                   value={formData.ref_no}
//                   placeholder="Example:- ABCD/EFG/2025-26/456"
//                   onChange={handleInputChange}
//                   className={`form-input width-15vw ${errors.ref_no ? 'error' : inputState.ref_no ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.ref_no && <span className="error-message">{errors.ref_no}</span>}
//               </div>
//               <div className="flex-column ">
//                 <label className="form-labels">Date:<span className="required">*</span></label>
//                 <input
//                   type="date"
//                   name="date"
//                   value={formData.date}
//                   placeholder="Example:- ABCD/EFG/2025-26/456"
//                   onChange={handleInputChange}
//                   className={`form-input width-15vw ${errors.date ? 'error' : inputState.date ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.date && <span className="error-message">{errors.date}</span>}
//               </div>
//               <div className="form-group">
//                 <label
//                   htmlFor="to"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Client Name <span className="required">*</span>
//                 </label>
//                 <Select
//                   options={ClientListData}
//                   onChange={handleClientChange}
//                   value={ClientListData.find(option => formData.to === option.value) || null}
//                   placeholder="Select a Client"
//                   isClearable
//                   isSearchable
//                   isMulti={false}
//                   inputValue={searchTerm}
//                   onInputChange={(input) => setSearchTerm(input)}
//                   noOptionsMessage={() => "No other options"}
//                   styles={CSSForSelect}
//                 />


//                 {errors.to && (
//                   <div className="error-message col">
//                     {errors.to}
//                   </div>
//                 )}
//               </div>
//               <div className="flex-column ">
//                 <label className="form-labels">Subject:<span className="required">*</span></label>
//                 <textarea
//                   type="text"
//                   name="subject"
//                   value={formData.subject}
//                   placeholder="Example:-  Quotation for Consultancy Services"
//                   onChange={handleInputChange}
//                   className={`form-input-textarea width-15vw ${errors.subject ? 'error' : inputState.subject ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.subject && <span className="error-message">{errors.subject}</span>}
//               </div>
//               <div className="flex-column ">
//                 <label className="form-labels">Project Details:<span className="required">*</span></label>
//                 <textarea
//                   type="text"
//                   name="project_details"
//                   value={formData.project_details}
//                   placeholder="Example:- Corporate HQ"
//                   onChange={handleInputChange}
//                   className={`form-input-textarea width-15vw ${errors.project_details ? 'error' : inputState.project_details ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.project_details && <span className="error-message">{errors.project_details}</span>}
//               </div>
//               <div className="form-group">
//                 <label
//                   htmlFor="to"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   WorkType <span className="required">*</span>
//                 </label>
//                 <Select
//                   options={workTypeDatra}
//                   onChange={handleWorkTypeChange}
//                   value={workTypeDatra.filter(option =>
//                     formData.worktype.some(wt => wt.id === option.value)
//                   )}
//                   placeholder="Select Work Types"
//                   isClearable
//                   isSearchable
//                   isMulti
//                   inputValue={searchTerm}
//                   onInputChange={(input) => setSearchTerm(input)}
//                   noOptionsMessage={() => "No other options"}
//                   styles={CSSForSelect}
//                 />
//                 {errors.to && (
//                   <div className="error-message col">
//                     {errors.to}
//                   </div>
//                 )}
//               </div>


//               {formData.notes?.length > 0 && (
//                 <table className="nested-table-lightblue width-90vw payment border-table">
//                   <thead className="border-table">
//                     <tr>
//                       <th className="text-center" style={{ width: "5%" }}>S.No.</th>
//                       <th className="text-start">Notes Description</th>

//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(() => {
//                       let serial = 1;
//                       return formData.notes.map((note, noteIndex) =>
//                         note.data.map((desc, descIndex) => {
//                           const currentSerial = serial++;
//                           return (
//                             <tr key={`${note.id}-${descIndex}`}>
//                               <td className="font-weight600 text-center">{currentSerial}.</td>
//                               <td className="notes-description">{desc.description}</td>

//                             </tr>
//                           );
//                         })
//                       );
//                     })()}
//                   </tbody>
//                 </table>
//               )}

//               <div style={{ display: "flex", justifyContent: "end", width: `100%`, marginBottom: `40px` }}>

//                 <div className="flex-column " >

//                   <button className="viewbutton" onClick={addNewDescription}>
//                     <AddwithWhiteCircle />  More Conditions
//                   </button>
//                 </div>
//               </div>
//               <div>


//               </div>

//             </div>

//             <div className='flex-row justify-between' style={{ flexWrap: "wrap" }}>

//               {formData.termsandconditions?.map((item, index) => (
//                 <div className="flex-column ">
//                   <div className='flex-row justify-between'>
//                     <label className="form-labels">({index + 1}).PAYMENT TERMS AND CONDITION :<span className="required">*</span></label>
//                     {formData.termsandconditions.length > 1 &&


//                       <button className="removebutton" onClick={() => removeDescription(index)}>
//                         <span className="text"
//                         >Remove</span><span className="icon">
//                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
//                             <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z">
//                             </path>
//                           </svg>
//                         </span>
//                       </button>
//                     }
//                   </div>

//                   <input
//                     type="text"
//                     name={`item_${index}`}
//                     value={item.item}
//                     placeholder="Example:- 50% payment as ABC work"
//                     onChange={(e) => handleDescriptionChange(index, e.target.value)}
//                     className={`form-input ${errors[`item_${index}`] ? 'error' : inputState[`item_${index}`] ? 'success' : ''}`}
//                   />
//                   {errors[`item_${index}`] && (
//                     <div className="error-message text-center">{errors[`item_${index}`]}</div>
//                   )}                </div>
//               ))}
//             </div>


//             <div style={{ display: "flex", justifyContent: "end", flexWrap: "wrap", gap: "10px" }}>
//               {formData.notes?.length > 0 &&
//                 formData.structured_field?.map((i) => (
//                   <div className="flex-column" key={i.usedfor}>
//                     <button
//                       type="button"
//                       className={expandedTables[i.usedfor] ? "viewbutton" : "viewbutton"}
//                       onClick={() => toggleTable(i.usedfor)}
//                     >
//                       {expandedTables[i.usedfor] ? (
//                         <>
//                           <CrosswithWITECircle /> Hide {i.usedfor} Detailed Proposal
//                         </>
//                       ) : (
//                         <>
//                           <AddwithWhiteCircle /> Add {i.usedfor} Detailed Proposal
//                         </>
//                       )}
//                     </button>
//                   </div>
//                 ))}
//             </div>

//             {/* ✅ Tables */}
//             {formData.notes?.length > 0 &&
//               formData.structured_field?.map((i, index) => (
//                 <div key={i.usedfor}>
//                   {expandedTables[i.usedfor] && (
//                     <>
//                       <h6>({index + 1}). Detailed Proposal of {i.usedfor}</h6>
//                       <div className="table-css-white-background scroll-container">
//                         <div className="table-container scrollbar" style={{ width: "100%" }}>
//                           <table className="nested-table-lightblue" style={{ margin: "0px" }}>
//                             <thead className="table-heading">
//                               <tr
//                                 className="custom-table-head-tr"
//                                 style={{ border: "1px solid #1a5276", padding: "8px", color: "#1a5276" }}
//                               >
//                                 <th
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                     color: "#1a5276",
//                                   }}
//                                 >
//                                   S.No.
//                                 </th>

//                                 {i.Data.map((headingObj, headingIndex) => (
//                                   <th
//                                     key={headingIndex}
//                                     style={{
//                                       border: "1px solid #1a5276",
//                                       padding: "8px",
//                                       background: "#e5dfec",
//                                     }}
//                                   >
//                                     <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                       <input
//                                         type="text"
//                                         value={headingObj.heading}
//                                         placeholder="Enter heading"
//                                         className="input"
//                                         onChange={(e) =>
//                                           handleHeadingChange(i.usedfor, headingIndex, e.target.value)
//                                         }
//                                       />
//                                       <button
//                                         type="button"
//                                         style={{
//                                           background: "#ff6b6b",
//                                           border: "none",
//                                           color: "BLACK",
//                                           borderRadius: "50%",
//                                           width: "20px",
//                                           height: "20px",
//                                           cursor: "pointer",
//                                           fontWeight: "bold",
//                                           fontSize: "14px",
//                                         }}
//                                         onClick={() => removeColumn(i.usedfor, headingIndex)}
//                                       >
//                                         ×
//                                       </button>
//                                     </div>
//                                   </th>
//                                 ))}

//                                 <th
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                   }}
//                                 >
//                                   <button
//                                     className="viewbutton"
//                                     onClick={() => addNewHeading(i.usedfor)}
//                                   >
//                                     <AddwithWhiteCircle /> Heading
//                                   </button>
//                                 </th>
//                               </tr>
//                             </thead>

//                             <tbody>
//                               {generateRows(i).map((row, rowIndex) => (
//                                 <tr className="custom-table-head-tr" key={rowIndex}>
//                                   <td style={{ border: "1px solid #1a5276", padding: "8px" }}>
//                                     {rowIndex + 1}
//                                   </td>

//                                   {row.map((cell, cellIndex) => (
//                                     <td
//                                       key={cellIndex}
//                                       style={{ border: "1px solid #1a5276", padding: "8px" }}
//                                     >
//                                       <input
//                                         type="text"
//                                         value={cell.item}
//                                         className="input"
//                                         placeholder="Enter item"
//                                         onChange={(e) =>
//                                           handleStructuredFieldChange(
//                                             i.usedfor,
//                                             cellIndex,
//                                             rowIndex,
//                                             e.target.value
//                                           )
//                                         }
//                                       />
//                                     </td>
//                                   ))}

//                                   <td style={{ border: "1px solid #1a5276", padding: "8px" }}>
//                                     {rowIndex === 0 ? (
//                                       <button
//                                         type="button"
//                                         className="viewbutton"
//                                         onClick={() => addNewItemToAllHeadings(i.usedfor)}
//                                       >
//                                         <AddwithWhiteCircle /> Row
//                                       </button>
//                                     ) : (
//                                       <button
//                                         type="button"
//                                         className="viewbutton"
//                                         onClick={() => handleRemoveRow(i.usedfor, rowIndex)}
//                                       >
//                                         <CrosswithWITECircle /> Remove
//                                       </button>
//                                     )}
//                                   </td>
//                                 </tr>
//                               ))}

//                               {/* ✅ Work Type Rate Row */}
//                               <tr className="total-row">
//                                 <td
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                   }}
//                                 ></td>
//                                 <td
//                                   className="text-end"
//                                   colSpan={generateRows(i)[0]?.length - 1 || 1}
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                   }}
//                                 >
//                                   {i.usedfor}
//                                 </td>
//                                 <td
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                   }}
//                                 >
//                                   <input
//                                     type="number"
//                                     className="input"
//                                     value={i.worktype_rate || ""}
//                                     placeholder="Enter work type rate"
//                                     onChange={(e) => handleWorkTypeRateChange(i.usedfor, e.target.value)}
//                                   />
//                                 </td>
//                                 <td
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                   }}
//                                 ></td>
//                               </tr>

//                               {/* ✅ Total Calculation Row */}
//                               <tr className="total-row">
//                                 <td
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                   }}
//                                 ></td>
//                                 <td
//                                   colSpan={generateRows(i)[0]?.length - 1 || 1}
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                     textAlign: "right",
//                                     fontWeight: "bold",
//                                   }}
//                                 >
//                                   Total:
//                                 </td>
//                                 <td
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                     fontWeight: "bold",
//                                   }}
//                                 >
//                                   {(() => {
//                                     const totalValue = generateRows(i).reduce((acc, row) => {
//                                       const lastCell = row[row.length - 1]?.item;
//                                       const value = parseFloat(lastCell) || 0;
//                                       return acc + value;
//                                     }, 0);

//                                     const totalWithRate = totalValue + (parseFloat(i.worktype_rate) || 0);
//                                     i.total = totalWithRate;

//                                     return totalWithRate.toFixed(2);
//                                   })()}
//                                 </td>
//                                 <td
//                                   style={{
//                                     border: "1px solid #1a5276",
//                                     padding: "8px",
//                                     background: "#e5dfec",
//                                     textAlign: "right",
//                                     fontWeight: "bold",
//                                   }}
//                                 ></td>
//                               </tr>
//                             </tbody>
//                           </table>


//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               ))}


//             {formData.notes?.length > 0 && (
//               <>
//                 <strong>
//                   Final Total Table
//                 </strong>
//                 <table
//                   className="nested-table-lightblue"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr style={{ backgroundColor: "#eaf2f8", color: "#1a5276" }}>
//                       <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>S.No.</th>
//                       <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Description</th>
//                       <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Amount</th>
//                       <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Action</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {formData.rate?.map((item, index) => (
//                       <tr key={index}>
//                         <td style={{ border: "1px solid #1a5276", textAlign: "center" }}>{index + 1}</td>

//                         <td style={{ border: "1px solid #1a5276" }}>
//                           <input
//                             className='input'
//                             type="text"
//                             value={item.description}
//                             placeholder="Enter description"
//                             onChange={(e) => handleRateChange(index, "description", e.target.value)}
//                           />
//                         </td>

//                         <td style={{ border: "1px solid #1a5276" }}>
//                           <input
//                             className='input'
//                             type="number"
//                             value={item.amount}
//                             placeholder="Enter amount"
//                             onChange={(e) => handleRateChange(index, "amount", e.target.value)}
//                           />
//                         </td>
//                         <td style={{ border: "1px solid #1a5276" }}>
//                           {index === 0 ? (
//                             <button type="button" className="viewbutton" onClick={addRateRow}>
//                               <AddwithWhiteCircle /> Row
//                             </button>
//                           ) : (
//                             <button
//                               type="button"
//                               className="viewbutton"
//                               onClick={() => removeRateRow(index)}

//                             >
//                               <CrosswithWITECircle /> Remove
//                             </button>)}
//                         </td>


//                       </tr>
//                     ))}



//                     {/* Total Row */}

//                   </tbody>
//                 </table>
//               </>

//             )}





//           </div>
//         </Modal.Body>
//         <div className="button-models-gap-116 " >
//           <div className="">

//             <button type="button" onClick={handleClose} className="cancelbutton">Cancel</button>
//           </div>

//           <div className="">
//             <button class="submitaddbutton" onClick={handleSubmit} type='submit'>
//               <span class="text">Submit</span>
//               <span class="icon">
//                 <svg
//                   viewBox="0 0 24 24"
//                   height="24"
//                   width="24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z">
//                   </path>
//                 </svg>
//               </span>
//             </button>

//           </div>

//         </div>

//         <p className="error-message font-size-text margin-top40px">
//           {isSubmitted && Object.keys(errors).length > 0 && (
//             Object.keys(errors).length > 3 ? (
//               <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
//             ) : (
//               Object.keys(errors).map((field) =>
//                 field.charAt(0).toUpperCase() + field.slice(1)
//               ).join(', ') + ' are required!'
//             )
//           )}
//         </p>
//       </Modal >
//     </>
//   );
// };


const getInitialQuotationForm = () => ({
  ref_no: "",
  date: null,
  data: [{ description: "" }],
  to: "",
  to_detail: "",
  subject: "",
  project_details: "",
  worktype: [{ id: "", name: "" }],
  note_ids: [],
  client_ids: [],
  notes: [],
  banking_details: "null",
  authority_details: "null",
  rate: [{ description: "", amount: "" }],
  workstages: [{ workStages: "", percentage: "" }],
  termsandconditions: [{ item: "" }],
  structured_field: [
    {
      usedfor: "",
      total: "",
      work_type_rate: "",
      Data: [{ heading: "", Data: [{ item: "" }] }],
    },
  ],
  subcompany_id: "85bc33a1-3a08-4f72-bedc-a3710d246239",
});

const AddQuatatations = ({ getNotes, worktypeName, getData }) => {
  const [formData, setFormData] = useState(getInitialQuotationForm());

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedTables, setExpandedTables] = useState({});
  const [activeSection, setActiveSection] = useState('basic');
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});
  const [approved, setApproved] = useState(false);
  const [company, setCompany] = useState([]);
  const [subcompany, setSubCompany] = useState([]);
  const [clientData, setClientData] = useState([]);

  /* ===================== TABS CONFIG ===================== */
  const sections = [
    { id: 'basic', label: 'Basic Info', icon: Info, color: '#3b82f6' },
    { id: 'work', label: 'Work Type & Notes', icon: Briefcase, color: '#8b5cf6' },
    { id: 'proposal', label: 'Detailed Proposal', icon: Table2, color: '#f59e0b' },
    { id: 'terms', label: 'Payment Terms', icon: ReceiptText, color: '#10b981' },
    { id: 'preview', label: 'Preview & Approve', icon: Eye, color: '#ef4444' },
  ];

  const tabRequiredFields = {
    basic: ['ref_no', 'date', 'to', 'subject', 'project_details'],
    work: ['worktype'],
    proposal: [],
    terms: [],
    preview: [],
  };

  const fieldLabels = {
    ref_no: 'Ref. Number',
    date: 'Date',
    to: 'Client Name',
    subject: 'Subject',
    project_details: 'Project Details',
    worktype: 'Work Type',
  };

  const isFilled = (field) =>
    field === 'worktype'
      ? formData.worktype?.some((w) => w.id)
      : !!formData[field];

  const getRequiredFields = (tab) => tabRequiredFields[tab] || [];
  const isSectionComplete = (tabId) => getRequiredFields(tabId).every(isFilled);

  const sectionProgress = Math.round(
    ((sections.filter((s) => getRequiredFields(s.id).length > 0 && isSectionComplete(s.id)).length +
      (approved ? 1 : 0)) /
      (sections.filter((s) => getRequiredFields(s.id).length > 0).length + 1)) *
    100
  );

  /* ===================== API ===================== */
  const getSubCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const getCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
      setCompany(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const company_name = sessionStorage.getItem('sub_company_name');
  const subcompanyId = subcompany.filter((i) => i.title === company_name);
  const company_id = subcompanyId.length > 0 ? subcompanyId[0].id : null;
  const companyids = sessionStorage.getItem('sub_company_id');

  const getClientData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL3}/project/clientbysubcompany/${companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? 'null' : '85bc33a1-3a08-4f72-bedc-a3710d246239'}/`
      );
      if (companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d") {
        setClientData(res.data.filter((i) => i.sub_company !== "85bc33a1-3a08-4f72-bedc-a3710d246239"));
      } else {
        setClientData(res.data);
      }
    } catch (err) {
      if (err.response) {
        const errorData = err.response.data;
        if (typeof errorData.error === 'string') {
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach((message) => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    }
  };

  useEffect(() => { getSubCompany(); }, []);
  useEffect(() => { getClientData(); }, [company_id]);

  // Reset approval as soon as the user leaves the preview tab
  useEffect(() => {
    if (activeSection !== 'preview') setApproved(false);
  }, [activeSection]);

  /* ===================== NOTES (remove only, directly in formData) ===================== */
  // Flat rows built from formData.notes, so what you see is exactly what is in formData
  const visibleNotes = (formData.notes || []).flatMap((note) =>
    (note.data || []).map((d, lineIndex) => ({
      key: `${note.id}-${lineIndex}`,
      noteId: note.id,
      lineIndex,
      text: d.description,
    }))
  );

  // Notes of the selected work types as they came from the API (used for Restore)
  const originalNotes = (getNotes || []).filter((note) =>
    (formData.worktype || []).some((wt) => wt.id === note.worktype?.id)
  );
  const countLines = (list) => list.reduce((sum, n) => sum + (n.data || []).length, 0);
  const notesWereRemoved = countLines(originalNotes) > visibleNotes.length;

  // Remove one line from formData.notes; drop the whole note (and its id) when no lines are left
  const removeNote = (row) => {
    setFormData((prev) => {
      const notes = (prev.notes || [])
        .map((n) =>
          n.id === row.noteId
            ? { ...n, data: (n.data || []).filter((_, i) => i !== row.lineIndex) }
            : n
        )
        .filter((n) => (n.data || []).length > 0);
      return { ...prev, notes, note_ids: notes.map((n) => n.id) };
    });
  };

  const restoreNotes = () => {
    setFormData((prev) => ({
      ...prev,
      notes: originalNotes,
      note_ids: originalNotes.map((n) => n.id),
    }));
  };

  // Same font style and size as the NOTE section of the quotation slip
  const quotationNoteTextStyle = {
    fontFamily: 'Arial, sans-serif',
    fontSize: '15px',
    lineHeight: 1.5,
    textAlign: 'justify',
    color: 'black',
  };

  /* ===================== MODAL ===================== */
  const handleShow = () => {
    setShow(true);
    setActiveSection('basic');
    getCompany();
  };

  const handleClose = () => {
    setShow(false);
    setFormData(getInitialQuotationForm());
    setErrors({});
    setInputState({});
    setTabValidationAttempted({});
    setExpandedTables({});
    setApproved(false);
    setActiveSection('basic');
  };

  /* ===================== SELECT OPTIONS ===================== */
  const ClientListData = (clientData || [])
    .filter((i) => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({ value: i.id, label: `${index + 1}. ${i.title}` }));

  const workTypeDatra = (worktypeName || [])
    .filter((i) => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({ value: i.id, label: `${index + 1}. ${i.title}` }));

  const handleClientChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, to_detail: selectedOption ? selectedOption.value : "" }));
    if (selectedOption) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u.to_detail;
        return u;
      });
    }
  };

  const handleWorkTypeChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      worktype: selectedOptions
        ? selectedOptions.map((option) => ({
          id: option.value,
          name: option.label.replace(/^\d+\.\s/, ''),
        }))
        : [],
    }));
    if (selectedOptions && selectedOptions.length) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u.worktype;
        return u;
      });
    }
  };

  /* ===================== EFFECTS (same logic) ===================== */
  useEffect(() => {
    setFormData((prev) => {
      if (!prev.termsandconditions || prev.termsandconditions.length === 0) return prev;
      const workstages = prev.termsandconditions.map((tc) => {
        const match = tc.item.match(/^(\d+)%\s*(.*)$/);
        return {
          percentage: match ? parseFloat(match[1]) : 0,
          workStages: match ? match[2].trim() : "",
        };
      });
      return { ...prev, workstages };
    });
  }, [formData.termsandconditions]);

  useEffect(() => {
    const filteredNotes = getNotes.filter((note) =>
      (formData.worktype || []).some((wt) => wt.id === note.worktype?.id)
    );
    const notesId = filteredNotes.map((i) => i.id);
    setFormData((prev) => ({ ...prev, notes: filteredNotes, note_ids: notesId }));
  }, [getNotes, formData.worktype]);

  useEffect(() => {
    if (!formData.worktype || formData.worktype.length === 0) return;
    setFormData((prev) => {
      const newFields = formData.worktype.map((wt) => {
        const existing = prev.structured_field.find((sf) => sf.usedfor === wt.name);
        return (
          existing || {
            usedfor: wt.name,
            Data: [{ heading: "", Data: [{ item: "" }] }],
          }
        );
      });
      return { ...prev, structured_field: newFields };
    });
  }, [formData.worktype]);

  /* ===================== HELPERS: rows / totals ===================== */
  const generateRows = (structuredField) => {
    const maxLength = Math.max(...structuredField.Data.map((h) => h.Data.length));
    return Array.from({ length: maxLength }, (_, rowIndex) =>
      structuredField.Data.map((headingObj) => headingObj.Data[rowIndex] || { item: "" })
    );
  };

  const computeTotal = (sf) => {
    const sum = generateRows(sf).reduce((acc, row) => {
      const lastCell = row[row.length - 1]?.item;
      return acc + (parseFloat(lastCell) || 0);
    }, 0);
    return sum + (parseFloat(sf.worktype_rate) || 0);
  };

  // Submit and Preview both use this same payload (same data = same slip)
  const buildPayload = () => ({
    ...formData,
    structured_field: (formData.structured_field || [])
      .filter((sf) => expandedTables[sf.usedfor])
      .map((sf) => ({ ...sf, total: computeTotal(sf) })),
  });

  const previewData = useMemo(() => {
    if (activeSection !== 'preview') return null;
    const payload = buildPayload();
    const client = (clientData || []).find((c) => c.id === formData.to);
    return {
      ...payload,
      id: 'preview',
      // `to` stays the client id; the readable client name goes into `to_detail`
      to_detail: client?.client_name || client?.title || "",
      subcompany: (company || []).find((c) => c.id === formData.subcompany_id) || {},
    };
  }, [activeSection, formData, expandedTables, clientData, company]);

  /* ===================== VALIDATION + NAV ===================== */
  const getTabErrors = (tab) => {
    const e = {};
    getRequiredFields(tab).forEach((f) => {
      if (!isFilled(f)) e[f] = `${fieldLabels[f] || f} is required!`;
    });
    return e;
  };

  const scrollBodyTop = () => {
    const c = document.querySelector('.modern-modal-body');
    if (c) c.scrollTop = 0;
  };

  const validateCurrentTab = () => {
    const e = getTabErrors(activeSection);
    setErrors((prev) => ({ ...prev, ...e }));
    setTabValidationAttempted((prev) => ({ ...prev, [activeSection]: true }));
    return Object.keys(e).length === 0;
  };

  const validateForm = () => {
    let all = {};
    sections.forEach((s) => { all = { ...all, ...getTabErrors(s.id) }; });
    setErrors(all);
    const firstBad = sections.find((s) => Object.keys(getTabErrors(s.id)).length > 0);
    if (firstBad) {
      setActiveSection(firstBad.id);
      setTabValidationAttempted((prev) => ({ ...prev, [firstBad.id]: true }));
      scrollBodyTop();
    }
    return Object.keys(all).length === 0;
  };

  const goToNextTab = () => {
    const idx = sections.findIndex((s) => s.id === activeSection);
    if (!validateCurrentTab()) { scrollBodyTop(); return; }
    if (sections[idx + 1]) {
      setErrors({});
      setActiveSection(sections[idx + 1].id);
      scrollBodyTop();
    }
  };

  const goToPreviousTab = () => {
    const idx = sections.findIndex((s) => s.id === activeSection);
    if (idx > 0) {
      setActiveSection(sections[idx - 1].id);
      setErrors({});
    }
  };

  const hasCurrentTabErrors = () => getRequiredFields(activeSection).some((f) => errors[f]);

  const getCurrentTabErrorMessage = () => {
    const missing = getRequiredFields(activeSection)
      .filter((f) => !isFilled(f))
      .map((f) => fieldLabels[f] || f);
    if (!missing.length) return null;
    return missing.length === 1
      ? `${missing[0]} is required to proceed`
      : `${missing.length} fields required: ${missing.join(', ')}`;
  };

  /* ===================== SUBMIT ===================== */
  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (!validateForm()) return;
    if (!approved) {
      toast.error("Please approve the preview first.");
      return;
    }

    const loadingToastId = toast.loading("Loading: Please wait...");
    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL3}/project/quotations/`, buildPayload());
      if (res.status === 200 || res.status === 201) {
        getData();
        handleClose();
        toast.dismiss(loadingToastId);
        toast.success("Quotation Added successfully!");
      } else {
        alert(res);
      }
    } catch (err) {
      if (err.response) {
        toast.dismiss(loadingToastId);
        const errorData = err.response.data;
        if (typeof errorData.error === 'string') {
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach((message) => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (activeSection !== 'preview') { goToNextTab(); return; }
    // On the Preview tab, Enter does not submit; only the footer button does
  };

  /* ===================== FIELD HANDLERS ===================== */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState((prev) => ({ ...prev, [name]: value }));
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (value.trim()) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u[name];
        return u;
      });
    }
  };

  const addNewDescription = () => {
    setFormData((prev) => ({
      ...prev,
      termsandconditions: [...prev.termsandconditions, { item: "" }],
    }));
  };

  const handleDescriptionChange = (index, value) => {
    setFormData((prev) => ({
      ...prev,
      termsandconditions: prev.termsandconditions.map((t, i) => (i === index ? { ...t, item: value } : t)),
    }));
    if (value.trim()) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u[`item_${index}`];
        return u;
      });
    }
  };

  const removeDescription = (index) => {
    setFormData((prev) => ({
      ...prev,
      termsandconditions: prev.termsandconditions.filter((_, i) => i !== index),
    }));
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[`item_${index}`];
      const reordered = {};
      Object.keys(updatedErrors).forEach((key) => {
        if (key.startsWith("item_")) {
          const idx = parseInt(key.split("_")[1], 10);
          reordered[`item_${idx > index ? idx - 1 : idx}`] = updatedErrors[key];
        } else {
          reordered[key] = updatedErrors[key];
        }
      });
      return reordered;
    });
  };

  const handleWorkTypeRateChange = (usedfor, value) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor ? { ...sf, worktype_rate: value } : sf
      ),
    }));
  };

  const toggleTable = (usedfor) => {
    setExpandedTables((prev) => {
      const isOpen = prev[usedfor];
      if (isOpen) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          structured_field: prevFormData.structured_field.map((sf) =>
            sf.usedfor === usedfor
              ? {
                ...sf,
                Data: [{ heading: "", Data: [{ item: "" }] }],
                worktype_rate: "",
                total: 0,
              }
              : sf
          ),
        }));
        return { ...prev, [usedfor]: false };
      }
      return { ...prev, [usedfor]: true };
    });
  };

  /* ===================== FINAL RATE TABLE ===================== */
  const addRateRow = () => {
    setFormData((prev) => ({ ...prev, rate: [...prev.rate, { description: "", amount: "" }] }));
  };

  const removeRateRow = (index) => {
    setFormData((prev) => ({ ...prev, rate: prev.rate.filter((_, i) => i !== index) }));
  };

  const handleRateChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      rate: prev.rate.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    }));
  };

  /* ===================== STRUCTURED FIELD ===================== */
  const handleStructuredFieldChange = (usedfor, headingIndex, itemIndex, value) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) => {
        if (sf.usedfor !== usedfor) return sf;
        const updatedData = sf.Data.map((headingObj, hIdx) => {
          if (hIdx !== headingIndex) return headingObj;
          const updatedItems = [...(headingObj.Data || [])];
          while (updatedItems.length <= itemIndex) updatedItems.push({ item: "" });
          updatedItems[itemIndex] = { item: value };
          return { ...headingObj, Data: updatedItems };
        });
        return { ...sf, Data: updatedData };
      }),
    }));
  };

  const addNewHeading = (usedfor) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? { ...sf, Data: [...sf.Data, { heading: "", Data: [{ item: "" }] }] }
          : sf
      ),
    }));
  };

  const handleHeadingChange = (usedfor, headingIndex, value) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? {
            ...sf,
            Data: sf.Data.map((hdg, idx) => (idx === headingIndex ? { ...hdg, heading: value } : hdg)),
          }
          : sf
      ),
    }));
  };

  const addNewItemToAllHeadings = (usedfor) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? {
            ...sf,
            Data: sf.Data.map((headingObj) => ({
              ...headingObj,
              Data: [...headingObj.Data, { item: "" }],
            })),
          }
          : sf
      ),
    }));
  };

  const handleRemoveRow = (usedfor, rowIndex) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? {
            ...sf,
            Data: sf.Data.map((col) => ({
              ...col,
              Data: (col.Data || []).filter((_, idx) => idx !== rowIndex),
            })),
          }
          : sf
      ),
    }));
  };

  const removeColumn = (usedfor, headingIndex) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((field) =>
        field.usedfor === usedfor
          ? { ...field, Data: field.Data.filter((_, index) => index !== headingIndex) }
          : field
      ),
    }));
  };

  /* ===================== RENDER HELPERS ===================== */
  const renderNavButtons = (showPrev, nextLabel = 'Next') => (
    <div className="section-navigation-buttons dual-buttons">
      <div className="nav-buttons-wrapper">
        {showPrev && (
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
        )}
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          {nextLabel} <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  /* ================= BASIC ================= */
  const renderBasic = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Info} color="#3b82f6" />
        <div>
          <h4>Basic Information</h4>
          <p className="section-subtitle">Reference, client and subject of the quotation</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-field">
          <label><FileText size={14} /> Ref. Number<span className="required">*</span></label>
          <input
            type="text"
            name="ref_no"
            value={formData.ref_no}
            placeholder="e.g. ABCD/EFG/2025-26/456"
            onChange={handleInputChange}
            className={errors.ref_no ? 'error' : inputState.ref_no ? 'success' : ''}
          />
          {errors.ref_no && <span className="error-message"><AlertCircle size={12} /> {errors.ref_no}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Date<span className="required">*</span></label>
          <input
            type="date"
            name="date"
            value={formData.date || ""}
            onChange={handleInputChange}
            className={errors.date ? 'error' : inputState.date ? 'success' : ''}
          />
          {errors.date && <span className="error-message"><AlertCircle size={12} /> {errors.date}</span>}
        </div>

        <div className="form-field full-width">
          <label><Building2 size={14} /> Client Name<span className="required">*</span></label>
          {/* <Select
            options={ClientListData}
            onChange={handleClientChange}
            value={ClientListData.find((o) => formData.to_detail === o.value) || null}
            placeholder="Select a Client"
            isClearable
            isSearchable
            isMulti={false}
            inputValue={searchTerm}
            onInputChange={(input) => setSearchTerm(input)}
            noOptionsMessage={() => "No other options"}
            styles={CSSForSelectModern}
          /> */}
          <input
            type="text"
            name="to"
            value={formData.to || ""}
            placeholder="Enter client name"
            onChange={handleInputChange}
            className={errors.to ? 'error' : inputState.to ? 'success' : ''}
          />
          {errors.to && <span className="error-message"><AlertCircle size={12} /> {errors.to}</span>}
        </div>

        <div className="form-field">
          <label><FileText size={14} /> Subject<span className="required">*</span></label>
          <textarea
            name="subject"
            rows={3}
            value={formData.subject}
            placeholder="e.g. Quotation for Consultancy Services"
            onChange={handleInputChange}
            className={errors.subject ? 'error' : inputState.subject ? 'success' : ''}
          />
          {errors.subject && <span className="error-message"><AlertCircle size={12} /> {errors.subject}</span>}
        </div>

        <div className="form-field">
          <label><FileText size={14} /> Project Details<span className="required">*</span></label>
          <textarea
            name="project_details"
            rows={3}
            value={formData.project_details}
            placeholder="e.g. Corporate HQ"
            onChange={handleInputChange}
            className={errors.project_details ? 'error' : inputState.project_details ? 'success' : ''}
          />
          {errors.project_details && <span className="error-message"><AlertCircle size={12} /> {errors.project_details}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          Next: Work Type & Notes <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  /* ================= WORK TYPE & NOTES ================= */
  const renderWork = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Briefcase} color="#8b5cf6" />
        <div>
          <h4>Work Type & Notes</h4>
          <p className="section-subtitle">Notes load automatically based on the work type; you can remove the ones you do not need</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-field full-width">
          <label><Briefcase size={14} /> Work Type<span className="required">*</span></label>
          <Select
            options={workTypeDatra}
            onChange={handleWorkTypeChange}
            value={workTypeDatra.filter((o) => formData.worktype.some((wt) => wt.id === o.value))}
            placeholder="Select Work Types"
            isClearable
            isSearchable
            isMulti
            inputValue={searchTerm}
            onInputChange={(input) => setSearchTerm(input)}
            noOptionsMessage={() => "No other options"}
            styles={CSSForSelectModern}
          />
          {errors.worktype && <span className="error-message"><AlertCircle size={12} /> {errors.worktype}</span>}
        </div>

        <div className="form-field full-width">
          {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <label style={{ margin: 0 }}>Notes</label>
            {notesWereRemoved && (
              <button type="button" className="btn-add-remark" onClick={restoreNotes}>
                Restore removed notes
              </button>
            )}
          </div> */}

          {visibleNotes.length > 0 ? (
            <div className="remark-table-wrapper" style={{ maxHeight: 320 }}>
              <table className="remark-table">
                <thead>
                  <tr>
                    <th style={{ width: 60 }}>S.No.</th>
                    <th>Notes Description</th>
                    {/* <th style={{ width: 90 }}>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {visibleNotes.map((note, index) => (
                    <tr key={note.key}>
                      <td style={quotationNoteTextStyle}>{index + 1}.</td>
                      <td className="remark-text" style={quotationNoteTextStyle}>
                        {note.text}
                      </td>
                      {/* <td>
                        <button
                          type="button"
                          className="remark-delete"
                          title="Remove note"
                          onClick={() => removeNote(note)}
                        >
                          <Trash2 size={15} />
                        </button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="remark-empty">
              <p>No notes found</p>
              <small>Select a work type to load its notes</small>
            </div>
          )}
        </div>
      </div>

      {renderNavButtons(true)}
    </div>
  );

  /* ================= DETAILED PROPOSAL (+ FINAL AMOUNT TABLE) ================= */
  const renderProposal = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Table2} color="#f59e0b" />
        <div>
          <h4>Detailed Proposal</h4>
          <p className="section-subtitle">Proposal table for each work type and the final amount table</p>
        </div>
      </div>

      {formData.worktype?.length > 0 ? (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
            {formData.structured_field?.map((i) => (
              <button
                key={i.usedfor}
                type="button"
                className="btn-add-remark"
                onClick={() => toggleTable(i.usedfor)}
              >
                {expandedTables[i.usedfor] ? (
                  <><MinusCircle size={16} /> Hide {i.usedfor}</>
                ) : (
                  <><Plus size={16} /> Add {i.usedfor} Proposal</>
                )}
              </button>
            ))}
          </div>

          {formData.structured_field?.map((i, index) =>
            expandedTables[i.usedfor] ? (
              <div className="form-subsection" key={i.usedfor}>
                <h5 className="subsection-title">
                  ({index + 1}). Detailed Proposal of {i.usedfor}
                </h5>
                <div className="remark-table-wrapper" style={{ maxHeight: 'none' }}>
                  <table className="remark-table quote-table">
                    <thead>
                      <tr>
                        <th style={{ width: 50 }}>S.No.</th>
                        {i.Data.map((headingObj, headingIndex) => (
                          <th key={headingIndex}>
                            <div className="quote-th-wrap">
                              <input
                                type="text"
                                className="quote-cell-input"
                                value={headingObj.heading}
                                placeholder="Enter heading"
                                onChange={(e) => handleHeadingChange(i.usedfor, headingIndex, e.target.value)}
                              />
                              <button
                                type="button"
                                className="remark-delete"
                                title="Remove column"
                                onClick={() => removeColumn(i.usedfor, headingIndex)}
                              >
                                <X size={14} />
                              </button>
                            </div>
                          </th>
                        ))}
                        <th style={{ width: 120 }}>
                          <button type="button" className="btn-add-remark" onClick={() => addNewHeading(i.usedfor)}>
                            <Plus size={14} /> Heading
                          </button>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {generateRows(i).map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          <td>{rowIndex + 1}</td>
                          {row.map((cell, cellIndex) => (
                            <td key={cellIndex}>
                              <input
                                type="text"
                                className="quote-cell-input"
                                value={cell.item}
                                placeholder="Enter item"
                                onChange={(e) =>
                                  handleStructuredFieldChange(i.usedfor, cellIndex, rowIndex, e.target.value)
                                }
                              />
                            </td>
                          ))}
                          <td>
                            {rowIndex === 0 ? (
                              <button type="button" className="btn-add-remark" onClick={() => addNewItemToAllHeadings(i.usedfor)}>
                                <Plus size={14} /> Row
                              </button>
                            ) : (
                              <button type="button" className="remark-delete" title="Remove row" onClick={() => handleRemoveRow(i.usedfor, rowIndex)}>
                                <Trash2 size={15} />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}

                      <tr className="quote-total-row">
                        <td></td>
                        <td colSpan={generateRows(i)[0]?.length - 1 || 1} style={{ textAlign: 'right', fontWeight: 600 }}>
                          {i.usedfor}
                        </td>
                        <td>
                          <input
                            type="number"
                            className="quote-cell-input"
                            value={i.worktype_rate || ""}
                            placeholder="Enter work type rate"
                            onChange={(e) => handleWorkTypeRateChange(i.usedfor, e.target.value)}
                          />
                        </td>
                        <td></td>
                      </tr>

                      <tr className="quote-total-row">
                        <td></td>
                        <td colSpan={generateRows(i)[0]?.length - 1 || 1} style={{ textAlign: 'right', fontWeight: 700 }}>
                          Total:
                        </td>
                        <td style={{ fontWeight: 700 }}>{computeTotal(i).toFixed(2)}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null
          )}

          {/* Final amount table */}
          <div className="form-subsection">
            <h5 className="subsection-title">Final Amount Table</h5>
            <div className="remark-table-wrapper" style={{ maxHeight: 'none' }}>
              <table className="remark-table quote-table">
                <thead>
                  <tr>
                    <th style={{ width: 60 }}>S.No.</th>
                    <th>Description</th>
                    <th style={{ width: 200 }}>Amount</th>
                    <th style={{ width: 110 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.rate?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          className="quote-cell-input"
                          type="text"
                          value={item.description}
                          placeholder="Enter description"
                          onChange={(e) => handleRateChange(index, "description", e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="quote-cell-input"
                          type="number"
                          value={item.amount}
                          placeholder="Enter amount"
                          onChange={(e) => handleRateChange(index, "amount", e.target.value)}
                        />
                      </td>
                      <td>
                        {index === 0 ? (
                          <button type="button" className="btn-add-remark" onClick={addRateRow}>
                            <Plus size={14} /> Row
                          </button>
                        ) : (
                          <button type="button" className="remark-delete" title="Remove row" onClick={() => removeRateRow(index)}>
                            <Trash2 size={15} />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div className="remark-empty">
          <p>Please select a Work Type first</p>
          <small>You can add the proposal after choosing a work type in the Work Type & Notes tab</small>
        </div>
      )}

      {renderNavButtons(true)}
    </div>
  );

  /* ================= PAYMENT TERMS ================= */
  const renderTerms = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={ReceiptText} color="#10b981" />
        <div>
          <h4>Payment Terms</h4>
          <p className="section-subtitle">Payment terms and conditions</p>
        </div>
      </div>

      <div className="form-subsection">
        <h5 className="subsection-title">Payment Terms and Conditions</h5>
        <div className="form-grid">
          {formData.termsandconditions?.map((item, index) => (
            <div className="form-field full-width" key={index}>
              <label style={{ justifyContent: 'space-between' }}>
                <span>({index + 1}). Payment Term<span className="required">*</span></span>
                {formData.termsandconditions.length > 1 && (
                  <button type="button" className="remark-delete" title="Remove" onClick={() => removeDescription(index)}>
                    <Trash2 size={15} />
                  </button>
                )}
              </label>
              <input
                type="text"
                name={`item_${index}`}
                value={item.item}
                placeholder="e.g. 50% payment as ABC work"
                onChange={(e) => handleDescriptionChange(index, e.target.value)}
                className={errors[`item_${index}`] ? 'error' : ''}
              />
              {errors[`item_${index}`] && (
                <span className="error-message"><AlertCircle size={12} /> {errors[`item_${index}`]}</span>
              )}
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
          <button type="button" className="btn-add-remark" onClick={addNewDescription}>
            <Plus size={16} /> More Conditions
          </button>
        </div>
      </div>

      {renderNavButtons(true, 'Next: Preview')}
    </div>
  );

  /* ================= PREVIEW & APPROVE ================= */
  const renderPreview = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Eye} color="#ef4444" />
        <div>
          <h4>Preview & Approve</h4>
          <p className="section-subtitle">Review the slip; the quotation can only be created after you approve it</p>
        </div>
      </div>

      <div className={`preview-approve-banner ${approved ? 'approved' : ''}`}>
        {approved ? <Check size={16} /> : <AlertCircle size={16} />}
        <span>
          {approved
            ? "Preview approved. You can now click Create Quotation."
            : "Please review the slip below carefully. If everything is correct, click Approve Preview."}
        </span>
      </div>

      <div className="quote-preview-wrap">
        {/* hideNotesEditor: the slip's own notes editor is not needed here; notes are edited in the Work Type & Notes tab */}
        {previewData && <QuotationManagement previewData={previewData} hideNotesEditor />}
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
        </div>
      </div>
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'basic': return renderBasic();
      case 'work': return renderWork();
      case 'proposal': return renderProposal();
      case 'terms': return renderTerms();
      case 'preview': return renderPreview();
      default: return renderBasic();
    }
  };

  /* ===================== RETURN ===================== */
  return (
    <>
      <AddModalButton onClick={handleShow} title="Add Quotation" />

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div className="header-icon-wrapper"><FileText size={24} /></div>
            <div>
              <Modal.Title>Add Quotation Details</Modal.Title>
              <p className="header-subtitle">Fill in the details, preview the slip and approve to create</p>
            </div>
          </div>
          <button type="button" className="close-btn" onClick={handleClose}><X size={20} /></button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          {/* Progress */}
          <div className="clean-progress-wrap">
            <div className="clean-progress-info">
              <span className="clean-progress-label">Progress</span>
              <span className="clean-progress-percent">{sectionProgress}%</span>
            </div>
            <div className="clean-progress-bar">
              <div className="clean-progress-fill" style={{ width: `${sectionProgress}%` }} />
            </div>
          </div>

          {/* Tabs */}
          <div className="section-navigation">
            {sections.map((section, index) => {
              const Icon = section.icon;
              const isComplete = isSectionComplete(section.id) && getRequiredFields(section.id).length > 0;
              const hasMissing = getRequiredFields(section.id).some((f) => !isFilled(f));
              const isActive = activeSection === section.id;
              return (
                <React.Fragment key={section.id}>
                  <button
                    type="button"
                    className={`section-nav-btn ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''} ${hasMissing && !isActive && tabValidationAttempted[section.id] ? 'has-warning' : ''}`}
                    style={{ "--section-color": section.color }}
                    onClick={() => {
                      if (activeSection === section.id) return;
                      if (validateCurrentTab()) {
                        setActiveSection(section.id);
                        setErrors({});
                      } else {
                        scrollBodyTop();
                      }
                    }}
                  >
                    <div className="nav-icon-wrap">
                      {isComplete && !isActive ? <Check size={14} /> : <Icon size={15} />}
                    </div>
                    <span>{section.label}</span>
                    {isActive && <ChevronRight size={14} className="nav-arrow" />}
                  </button>
                  {index < sections.length - 1 && <div className="nav-divider" />}
                </React.Fragment>
              );
            })}
          </div>

          <form onSubmit={handleFormSubmit} className="project-form">
            {renderCurrentSection()}
          </form>
        </Modal.Body>

        {activeSection === 'preview' && (
          <Modal.Footer className="modern-modal-footer">
            <button type="button" className="btn-prev" onClick={goToPreviousTab}>
              <ChevronRight size={16} className="rotate-left" /> Previous
            </button>
            <div className="submit-buttons">
              <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
              <button
                type="button"
                className="btn-secondaryy"
                onClick={() => setApproved((p) => !p)}
              >
                <Check size={16} /> {approved ? 'Approved (click to undo)' : 'Approve Preview'}
              </button>
              <button
                type="button"
                className="btn-primaryy"
                disabled={loading || !approved}
                onClick={handleSubmit}
                title={!approved ? "Please approve the preview first" : ""}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                <span>{loading ? 'Creating...' : 'Create Quotation'}</span>
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

// const UpdateQuotations = ({ getNotes, worktypeName, getData, i }) => {
//   const [formData, setFormData] = useState({
//     ref_no: "",
//     date: null,
//     data: [{
//       description: "",
//     }],
//     to: "",
//     subject: "",
//     project_details: "",
//     worktype: [{
//       id: "",
//       name: "",
//     }],
//     note_ids: [],
//     client_ids: [],
//     notes: [],
//     rate: [{
//       description: ``,
//       amount: ``,
//     }],
//     workstages: [{
//       workStages: "",
//       percentage: "",
//     }],

//     termsandconditions: [{
//       item: ""
//     }],

//     structured_field: [
//       {
//         usedfor: "",
//         total: "",
//         work_type_rate: "",
//         Data: [
//           {
//             heading: "",
//             Data: [{
//               item: "",
//             }]
//           }
//         ]
//       }
//     ],

//     subcompany_id: "85bc33a1-3a08-4f72-bedc-a3710d246239",

//   });


//   console.log("i")
//   console.log(i)




//   const [subcompany, setSubCompany] = useState([])
//   const getSubCompany = async () => {

//     try {
//       const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
//       setSubCompany(res.data);
//     } catch (err) {
//       handleErrorToast(err)
//     } finally {
//     }
//   };

//   useEffect(() => {
//     getSubCompany();
//   }, [])

//   const company_name = sessionStorage.getItem('sub_company_name');
//   const subcompanyId = subcompany.filter(i => i.title === company_name);

//   console.log("company_name", company_name);
//   console.log("subcompanyId", subcompanyId);


//   const company_id = subcompanyId.length > 0 ? subcompanyId[0].id : null;

//   console.log("company_id", company_id);

//   const [clientData, setClientData] = useState([]);

//   const companyids = sessionStorage.getItem('sub_company_id');

//   const getClientData = async () => {

//     try {
//       const res = await axios.get(`${BASE_URL3}/project/clientbysubcompany/${companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? 'null' : '85bc33a1-3a08-4f72-bedc-a3710d246239'}/`);

//       if (companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d") {
//         setClientData(res.data.filter(i => i.sub_company !== "85bc33a1-3a08-4f72-bedc-a3710d246239"))

//       }
//       else {
//         setClientData(res.data)

//       }
//     } catch (err) {
//       //toast Logic
//       if (err.response) {
//         const errorData = err.response.data;

//         if (typeof errorData.error === 'string') {
//           // Single error message
//           toast.error(`Error: ${errorData.error}`);
//         } else if (typeof errorData === 'object' && errorData !== null) {
//           // Multiple error messages
//           Object.entries(errorData).forEach(([field, messages]) => {
//             messages.forEach(message => toast.error(`"${field}": ${message}`));
//           });
//         } else {
//           toast.error('Error:- Failed to Process!');
//         }
//       } else {
//         toast.error('Error processing your request.');
//       }
//     } finally {
//     }
//   }

//   useEffect(() => {
//     if (company_id !== null) {
//       getClientData();
//     }
//   }, [company_id]);



//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const [show, setShow] = useState(false);

//   const handleShow = () => {

//     setShow(true);
//     setFormData(i);

//     getCompany();
//   }

//   const handleClose = () => {
//     setShow(false);


//     setErrors({});
//   }

//   const [searchTerm, setSearchTerm] = useState("");

//   const ClientListData = (clientData || [])
//     .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
//     .sort((a, b) => a.title.localeCompare(b.title))
//     .map((i, index) => ({
//       value: i.id,
//       label: `${index + 1}. ${i.title}`,
//     }));

//   const handleClientChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         to: "",
//       });
//     } else {
//       setFormData({
//         ...formData,
//         to: selectedOption.value,
//       });
//     }
//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.project;
//       return updatedErrors;
//     });
//   };
//   const workTypeDatra = (worktypeName || [])
//     .filter(i => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
//     .sort((a, b) => a.title.localeCompare(b.title))
//     .map((i, index) => ({
//       value: i.id,
//       label: `${index + 1}. ${i.title}`,
//     }));

//   const handleWorkTypeChange = (selectedOptions) => {
//     if (!selectedOptions) {
//       setFormData({
//         ...formData,
//         worktype: [],
//       });
//     } else {
//       setFormData({
//         ...formData,
//         worktype: selectedOptions.map(option => ({
//           id: option.value,
//           name: option.label.replace(/^\d+\.\s/, '')
//         })),
//       });
//     }

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors.worktype_id;
//       return updatedErrors;
//     });
//   };
//   useEffect(() => {
//     if (!i) return;

//     const NOTESdATA = Array.isArray(i)
//       ? i.flatMap(item => item.notes || [])
//       : (i?.notes ? i.notes : []);

//     console.log("NOTESdATA:", NOTESdATA);

//     setFormData(prev => ({
//       ...prev,
//       notes: NOTESdATA,
//     }));
//   }, [i]);
//   useEffect(() => {
//     if (!i) return;

//     const STRUCTUREdETAILS = Array.isArray(i)
//       ? i.flatMap(item => item.structured_field || [])
//       : (i?.structured_field ? i.structured_field : []);

//     console.log("structured_fielddATA:", STRUCTUREdETAILS);

//     setFormData(prev => ({
//       ...prev,
//       structured_field: STRUCTUREdETAILS,
//     }));
//   }, [i]);


//   useEffect(() => {
//     setFormData(prev => {
//       if (!prev.termsandconditions || prev.termsandconditions.length === 0) return prev;

//       const workstages = prev.termsandconditions.map(tc => {
//         const match = tc.item.match(/^(\d+)%\s*(.*)$/);
//         return {
//           percentage: match ? parseFloat(match[1]) : 0,
//           workStages: match ? match[2].trim() : ""
//         };
//       });

//       return { ...prev, workstages };
//     });
//   }, [formData.termsandconditions]);


//   console.log("formData")
//   console.log(formData)

//   useEffect(() => {
//     if (!Array.isArray(getNotes) || !Array.isArray(formData?.worktype)) return;

//     const filteredNotes = getNotes.filter(note =>
//       formData.worktype.some(wt => wt?.id === note?.worktype?.id)
//     );

//     const newNotes = filteredNotes.filter(
//       note => !formData.notes?.some(existing => existing.id === note.id)
//     );

//     const mergedNotes = [...(formData.notes || []), ...newNotes];
//     const notesId = mergedNotes.map(note => note.id);

//     setFormData(prev => ({
//       ...prev,
//       notes: mergedNotes,
//       note_ids: notesId,
//     }));
//   }, [getNotes, formData.worktype]);


//   useEffect(() => {
//     if (!formData.worktype || formData.worktype.length === 0) {
//       return;
//     }

//     setFormData(prev => {
//       const newFields = formData.worktype.map(wt => {
//         const existing = prev.structured_field.find(sf => sf.usedfor === wt.name);
//         return existing || {
//           usedfor: wt.name,
//           Data: [
//             {
//               heading: "",
//               Data: [{ item: "" }]
//             }
//           ]
//         };
//       });

//       return {
//         ...prev,
//         structured_field: newFields
//       };
//     });
//   }, [formData.worktype]);








//   const addNewDescription = () => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       termsandconditions: [...prevFormData.termsandconditions, { item: "" }],
//     }));
//   };

//   const handleDescriptionChange = (index, value) => {
//     const updatedData = [...formData.termsandconditions];


//     if (!updatedData[index]) {
//       updatedData[index] = { item: "" };
//     }

//     updatedData[index].item = value;
//     setFormData({ ...formData, termsandconditions: updatedData });


//     if (value.trim()) {
//       setErrors((prevErrors) => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[`item_${index}`];
//         return updatedErrors;
//       });
//     }
//   };

//   const handleWorkTypeRateChange = (usedfor, value) => {
//     setFormData(prev => {
//       const structured_field = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           return { ...sf, worktype_rate: value };
//         }
//         return sf;
//       });

//       return { ...prev, structured_field };
//     });
//   };


//   const fileInputRefs = useRef([]);

//   const handleRemoveData = (index) => {
//     setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
//     fileInputRefs.current.splice(index, 1);
//   };


//   const [errors, setErrors] = useState({});

//   const [inputState, setInputState] = useState({});

//   const validateForm = () => {
//     const newErrors = {};

//     const requiredFields = [];
//     requiredFields.forEach((field) => {
//       if (!formData[field] || formData[field] === "null") {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });



//     setErrors(newErrors);
//     setIsSubmitted(true);

//     return Object.keys(newErrors).length === 0;
//   };



//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {

//       const loadingToastId = toast.loading("Loading: Please wait...");
//       setLoading(true);
//       try {
//         let res = await axios.put(`${BASE_URL3}/project/quotations/${i.id}/`, formData);

//         if (res.status === 200 || res.status === 200) {
//           getData();
//           handleClose();
//           toast.dismiss(loadingToastId);
//           toast.success("Quotation Details Updated successfully!");

//         } else {
//           alert(res);
//         }
//       } catch (err) {
//         if (err.response) {
//           toast.dismiss(loadingToastId);
//           const errorData = err.response.data;

//           if (typeof errorData.error === 'string') {
//             toast.error(`Error: ${errorData.error}`);
//           } else if (typeof errorData === 'object' && errorData !== null) {
//             Object.entries(errorData).forEach(([field, messages]) => {
//               messages.forEach(message => toast.error(`"${field}": ${message}`));
//             });
//           } else {
//             toast.error('Error:- Failed to Process!');
//           }
//         } else {
//           toast.error('Error processing your request.');
//         }
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }

//     }
//   };
//   const [company, setCompany] = useState([]);

//   const getCompany = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
//       setCompany(res.data);
//     } catch (error) {
//       console.error(error);

//     }
//   }




//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: value,
//     });

//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     if (value.trim()) {
//       setErrors((prevErrors) => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[name];
//         return updatedErrors;
//       });
//     }
//   };


//   const removeDescription = (index) => {
//     const updatedData = formData.termsandconditions.filter((_, i) => i !== index);
//     setFormData({ ...formData, termsandconditions: updatedData });

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       delete updatedErrors[`item_${index}`];

//       const reorderedErrors = {};
//       Object.keys(updatedErrors).forEach((key) => {
//         if (key.startsWith("item_")) {
//           const idx = parseInt(key.split("_")[1], 10);
//           reorderedErrors[
//             `item_${idx > index ? idx - 1 : idx}`
//           ] = updatedErrors[key];
//         } else {
//           reorderedErrors[key] = updatedErrors[key];
//         }
//       });

//       return reorderedErrors;
//     });
//   };



//   const [expandedTables, setExpandedTables] = useState({});

//   const toggleTable = (usedfor) => {
//     setExpandedTables(prev => ({
//       ...prev,
//       [usedfor]: !prev[usedfor]
//     }));
//   };

























//   const addRateRow = () => {
//     setFormData((prev) => ({
//       ...prev,
//       rate: [...prev.rate, { description: "", amount: "" }],
//     }));
//   };


//   const removeRateRow = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       rate: prev.rate.filter((_, i) => i !== index),
//     }));
//   };


//   const handleRateChange = (index, field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       rate: prev.rate.map((item, i) =>
//         i === index ? { ...item, [field]: value } : item
//       ),
//     }));
//   };



//   const handleStructuredFieldChange = (usedfor, headingIndex, itemIndex, value) => {
//     setFormData(prev => {
//       const structured_field = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           const updatedData = sf.Data.map((headingObj, hIdx) => {
//             if (hIdx === headingIndex) {

//               const updatedItems = [...(headingObj.Data || [])];
//               while (updatedItems.length <= itemIndex) {
//                 updatedItems.push({ item: "" });
//               }
//               updatedItems[itemIndex] = { item: value };
//               return { ...headingObj, Data: updatedItems };
//             }
//             return headingObj;
//           });
//           return { ...sf, Data: updatedData };
//         }
//         return sf;
//       });
//       return { ...prev, structured_field };
//     });
//   };

//   useEffect(() => {
//     if (!Array.isArray(formData.worktype) || formData.worktype.length === 0) return;

//     setFormData(prev => {
//       const existingFields = Array.isArray(prev.structured_field) ? prev.structured_field : [];

//       const newFields = formData.worktype.map(wt => {
//         const existing = existingFields.find(sf => sf.usedfor === wt.name);
//         return (
//           existing || {
//             usedfor: wt.name,
//             Data: [
//               {
//                 heading: "",
//                 Data: [{ item: "" }],
//               },
//             ],
//           }
//         );
//       });


//       const remainingFields = existingFields.filter(sf =>
//         formData.worktype.some(wt => wt.name === sf.usedfor)
//       );

//       return {
//         ...prev,
//         structured_field: [...remainingFields, ...newFields],
//       };
//     });
//   }, [formData.worktype]);




//   const addNewHeading = (usedfor) => {
//     setFormData(prev => {
//       const updatedStructuredField = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           return {
//             ...sf,
//             Data: [...sf.Data, { heading: "", Data: [{ item: "" }] }]
//           };
//         }
//         return sf;
//       });

//       return {
//         ...prev,
//         structured_field: updatedStructuredField
//       };
//     });
//   };

//   const handleRemoveDescription = (noteIndex, descIndex) => {
//     setFormData((prev) => {
//       const updatedNotes = [...prev.notes];
//       updatedNotes[noteIndex].data = updatedNotes[noteIndex].data.filter(
//         (_, i) => i !== descIndex
//       );




//       return { ...prev, notes: updatedNotes };
//     });
//   };

//   const handleHeadingChange = (usedfor, headingIndex, value) => {
//     setFormData(prev => {
//       const updatedStructuredField = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           const updatedData = sf.Data.map((hdg, idx) => {
//             if (idx === headingIndex) {
//               return { ...hdg, heading: value };
//             }
//             return hdg;
//           });
//           return { ...sf, Data: updatedData };
//         }
//         return sf;
//       });

//       return { ...prev, structured_field: updatedStructuredField };
//     });
//   };

//   const generateRows = (structuredField) => {
//     const maxLength = Math.max(...structuredField.Data.map(h => h.Data.length));

//     const rows = Array.from({ length: maxLength }, (_, rowIndex) =>
//       structuredField.Data.map((headingObj) => {
//         return headingObj.Data[rowIndex] || { item: "" };
//       })
//     );

//     return rows;
//   };

//   const addNewItemToAllHeadings = (usedfor) => {
//     setFormData(prev => {
//       const updatedStructuredField = prev.structured_field.map(sf => {
//         if (sf.usedfor === usedfor) {
//           const updatedData = sf.Data.map((headingObj) => ({
//             ...headingObj,
//             Data: [...headingObj.Data, { item: "" }]
//           }));
//           return {
//             ...sf,
//             Data: updatedData
//           };
//         }
//         return sf;
//       });

//       return {
//         ...prev,
//         structured_field: updatedStructuredField
//       };
//     });
//   };

//   const handleRemoveRow = (usedfor, rowIndex) => {
//     setFormData(prev => {
//       const updated = { ...prev };
//       const section = updated.structured_field.find(sf => sf.usedfor === usedfor);

//       if (section && section.Data?.length > 0) {
//         section.Data.forEach(col => {
//           if (col?.Data && col.Data[rowIndex] !== undefined) {
//             col.Data.splice(rowIndex, 1);
//           }
//         });
//       }

//       return { ...updated };
//     });
//   };


//   const removeColumn = (usedfor, headingIndex) => {
//     setFormData((prev) => {
//       const updatedFields = prev.structured_field.map((field) => {
//         if (field.usedfor === usedfor) {

//           const newData = field.Data.filter((_, index) => index !== headingIndex);


//           const updatedData = newData.map((headingObj) => {
//             return {
//               ...headingObj,
//               Data: headingObj.Data.map((cellObj) => cellObj)
//             };
//           });

//           return { ...field, Data: updatedData };
//         }
//         return field;
//       });

//       return { ...prev, structured_field: updatedFields };
//     });
//   };

//   return (
//     <>
//       <button className='model-edit-button' onClick={handleShow}>
//         <UpdatePencil />
//       </button>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
//         <Modal.Header closeButton>
//           <Modal.Title>Add Quatations</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">

//             <div className='form-flex-wrap' style={{ justifyContent: "space-between" }}>

//               <div className="flex-column ">
//                 <label className="form-labels">Ref. Number:<span className="required">*</span></label>
//                 <input
//                   type="text"
//                   name="ref_no"
//                   value={formData.ref_no}
//                   placeholder="Example:- ABCD/EFG/2025-26/456"
//                   onChange={handleInputChange}
//                   className={`form-input width-15vw ${errors.ref_no ? 'error' : inputState.ref_no ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.ref_no && <span className="error-message">{errors.ref_no}</span>}
//               </div>
//               <div className="flex-column ">
//                 <label className="form-labels">Date:<span className="required">*</span></label>
//                 <input
//                   type="date"
//                   name="date"
//                   value={formData.date}
//                   placeholder="Example:- ABCD/EFG/2025-26/456"
//                   onChange={handleInputChange}
//                   className={`form-input width-15vw ${errors.date ? 'error' : inputState.date ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.date && <span className="error-message">{errors.date}</span>}
//               </div>
//               <div className="form-group">
//                 <label
//                   htmlFor="to"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   Client Name <span className="required">*</span>
//                 </label>
//                 <Select
//                   options={ClientListData}
//                   onChange={handleClientChange}
//                   value={ClientListData.find(option => formData.to === option.value) || null}
//                   placeholder="Select a Client"
//                   isClearable
//                   isSearchable
//                   isMulti={false}
//                   inputValue={searchTerm}
//                   onInputChange={(input) => setSearchTerm(input)}
//                   noOptionsMessage={() => "No other options"}
//                   styles={CSSForSelect}
//                 />


//                 {errors.to && (
//                   <div className="error-message col">
//                     {errors.to}
//                   </div>
//                 )}
//               </div>
//               <div className="flex-column ">
//                 <label className="form-labels">Subject:<span className="required">*</span></label>
//                 <textarea
//                   type="text"
//                   name="subject"
//                   value={formData.subject}
//                   placeholder="Example:-  Quotation for Consultancy Services"
//                   onChange={handleInputChange}
//                   className={`form-input-textarea width-15vw ${errors.subject ? 'error' : inputState.subject ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.subject && <span className="error-message">{errors.subject}</span>}
//               </div>
//               <div className="flex-column ">
//                 <label className="form-labels">Project Details:<span className="required">*</span></label>
//                 <textarea
//                   type="text"
//                   name="project_details"
//                   value={formData.project_details}
//                   placeholder="Example:- Corporate HQ"
//                   onChange={handleInputChange}
//                   className={`form-input-textarea width-15vw ${errors.project_details ? 'error' : inputState.project_details ? 'success' : ''}`}
//                   style={{ width: "18vw" }}
//                 />
//                 {errors.project_details && <span className="error-message">{errors.project_details}</span>}
//               </div>
//               {/* <div className="form-group">
//                 <label
//                   htmlFor="to"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   WorkType <span className="required">*</span>
//                 </label>
//                 <Select
//                   options={workTypeDatra}
//                   onChange={handleWorkTypeChange}
//                   value={workTypeDatra.filter(option =>
//                     formData.worktype?.some(wt => wt.id === option.value)
//                   )}
//                   placeholder="Select Work Types"
//                   isClearable
//                   isSearchable
//                   isMulti   
//                   inputValue={searchTerm}
//                   onInputChange={(input) => setSearchTerm(input)}
//                   noOptionsMessage={() => "No other options"}
//                   styles={CSSForSelect}
//                 />
//                 {errors.to && (
//                   <div className="error-message col">
//                     {errors.to}
//                   </div>
//                 )}
//               </div> */}


//               {formData.notes?.length > 0 && (
//                 <table className="nested-table-lightblue width-90vw payment border-table">
//                   <thead className="border-table">
//                     <tr>
//                       <th className="text-center" style={{ width: "5%" }}>S.No.</th>
//                       <th className="text-start">Notes Description</th>

//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(() => {
//                       let serial = 1;
//                       return formData.notes.map((note, noteIndex) =>
//                         note.data.map((desc, descIndex) => {
//                           const currentSerial = serial++;
//                           return (
//                             <tr key={`${note.id}-${descIndex}`}>
//                               <td className="font-weight600 text-center">{currentSerial}.</td>
//                               <td className="notes-description">{desc.description}</td>

//                             </tr>
//                           );
//                         })
//                       );
//                     })()}
//                   </tbody>
//                 </table>
//               )}

//               <div style={{ display: "flex", justifyContent: "end", width: `100%`, marginBottom: `40px` }}>

//                 <div className="flex-column " >

//                   <button className="viewbutton" onClick={addNewDescription}>
//                     <AddwithWhiteCircle />  More Conditions
//                   </button>
//                 </div>
//               </div>
//               <div>


//               </div>

//             </div>

//             <div className='flex-row justify-between' style={{ flexWrap: "wrap" }}>

//               {formData.termsandconditions?.map((item, index) => (
//                 <div className="flex-column ">
//                   <div className='flex-row justify-between'>
//                     <label className="form-labels">({index + 1}).PAYMENT TERMS AND CONDITION :<span className="required">*</span></label>
//                     {formData.termsandconditions.length > 1 &&


//                       <button className="removebutton" onClick={() => removeDescription(index)}>
//                         <span className="text"
//                         >Remove</span><span className="icon">
//                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
//                             <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z">
//                             </path>
//                           </svg>
//                         </span>
//                       </button>
//                     }
//                   </div>

//                   <input
//                     type="text"
//                     name={`item_${index}`}
//                     value={item.item}
//                     placeholder="Example:- 50% payment as ABC work"
//                     onChange={(e) => handleDescriptionChange(index, e.target.value)}
//                     className={`form-input ${errors[`item_${index}`] ? 'error' : inputState[`item_${index}`] ? 'success' : ''}`}
//                   />
//                   {errors[`item_${index}`] && (
//                     <div className="error-message text-center">{errors[`item_${index}`]}</div>
//                   )}                </div>
//               ))}
//             </div>


//             {formData.notes?.length > 0 && (
//               <>
//                 {formData.structured_field?.map((i, index) => (
//                   <div key={i.usedfor}>
//                     {/* 🔹 Always show each proposal section */}
//                     <h6>({index + 1}). Detailed Proposal of {i.usedfor}</h6>

//                     <div className="table-css-white-background scroll-container">
//                       <div className="table-container scrollbar" style={{ width: "100%" }}>
//                         <table className="nested-table-lightblue" style={{ margin: "0px" }}>
//                           <thead className="table-heading">
//                             <tr className="custom-table-head-tr " style={{ border: "1px solid #1a5276", padding: "8px", color: "#1a5276" }}>
//                               <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, color: "#1a5276" }}>S.No.</th>
//                               {i.Data.map((headingObj, headingIndex) => (
//                                 <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }} key={headingIndex}>
//                                   <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                     <input
//                                       type="text"
//                                       value={headingObj.heading}
//                                       placeholder="Enter heading"
//                                       className='input'
//                                       onChange={(e) =>
//                                         handleHeadingChange(i.usedfor, headingIndex, e.target.value)
//                                       }
//                                     />
//                                     <button
//                                       type="button"
//                                       style={{
//                                         background: "#ff6b6b",
//                                         border: "none",
//                                         color: "BLACK",
//                                         borderRadius: "50%",
//                                         width: "20px",
//                                         height: "20px",
//                                         cursor: "pointer",
//                                         fontWeight: "bold",
//                                         fontSize: "14px",
//                                       }}
//                                       onClick={() => removeColumn(i.usedfor, headingIndex)}
//                                     >
//                                       ×
//                                     </button>
//                                   </div>
//                                 </th>
//                               ))}
//                               <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>
//                                 <button
//                                   className="viewbutton"
//                                   onClick={() => addNewHeading(i.usedfor)}
//                                 >
//                                   <AddwithWhiteCircle />  Heading
//                                 </button>
//                               </th>
//                             </tr>
//                           </thead>

//                           <tbody>
//                             {generateRows(i).map((row, rowIndex) => (
//                               <tr className='custom-table-head-tr ' key={rowIndex}>
//                                 <td style={{ border: "1px solid #1a5276", padding: "8px" }}>{rowIndex + 1}</td>

//                                 {row.map((cell, cellIndex) => (
//                                   <td
//                                     style={{
//                                       border: "1px solid #1a5276", padding: "8px"
//                                     }}
//                                     key={cellIndex}>
//                                     <input
//                                       type="text"
//                                       value={cell.item}
//                                       className='input'
//                                       placeholder="Enter item"
//                                       onChange={(e) =>
//                                         handleStructuredFieldChange(
//                                           i.usedfor,
//                                           cellIndex,
//                                           rowIndex,
//                                           e.target.value
//                                         )
//                                       }
//                                     />
//                                   </td>
//                                 ))}

//                                 <td style={{ border: "1px solid #1a5276", padding: "8px" }}>
//                                   {rowIndex === 0 ? (
//                                     <button
//                                       type="button"
//                                       className="viewbutton"
//                                       onClick={() => addNewItemToAllHeadings(i.usedfor)}
//                                     >
//                                       <AddwithWhiteCircle /> Row
//                                     </button>
//                                   ) : (
//                                     <button
//                                       type="button"
//                                       className="viewbutton"
//                                       onClick={() => handleRemoveRow(i.usedfor, rowIndex)}

//                                     >
//                                       <CrosswithWITECircle /> Remove
//                                     </button>
//                                   )}
//                                 </td>
//                               </tr>

//                             ))}
//                             {/* ✅ Total Row */}
//                             <tr className="total-row ">
//                               <td style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}></td>
//                               <td
//                                 style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}
//                                 className="text-end"
//                                 colSpan={generateRows(i)[0]?.length - 1 || 1}
//                               >
//                                 {i.usedfor}
//                               </td>
//                               <td
//                                 style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>
//                                 <input
//                                   type="number"
//                                   className='input'
//                                   value={i.worktype_rate || ""}
//                                   placeholder="Enter work type rate"
//                                   onChange={(e) => handleWorkTypeRateChange(i.usedfor, e.target.value)}
//                                 />
//                               </td>
//                               <td style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}></td>
//                             </tr>

//                             <tr className="total-row ">
//                               <td
//                                 style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}></td>
//                               <td
//                                 colSpan={generateRows(i)[0]?.length - 1 || 1}
//                                 style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, textAlign: "right", fontWeight: "bold" }}
//                               >
//                                 Total:
//                               </td>
//                               <td style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, fontWeight: "bold" }}
//                               >
//                                 {(() => {
//                                   const totalValue = generateRows(i).reduce((acc, row) => {
//                                     const lastCell = row[row.length - 1]?.item;
//                                     const value = parseFloat(lastCell) || 0;
//                                     return acc + value;
//                                   }, 0);

//                                   const totalWithRate = totalValue + (parseFloat(i.worktype_rate) || 0);
//                                   i.total = totalWithRate;

//                                   return totalWithRate.toFixed(2);
//                                 })()}
//                               </td>
//                               <td
//                                 style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec`, textAlign: "right", fontWeight: "bold" }}
//                               ></td>
//                             </tr>

//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </>
//             )}

//             <strong>
//               Final Total Table
//             </strong>
//             {formData.notes?.length > 0 && (
//               <table
//                 className="nested-table-lightblue"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr style={{ backgroundColor: "#eaf2f8", color: "#1a5276" }}>
//                     <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>S.No.</th>
//                     <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Description</th>
//                     <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Amount</th>
//                     <th style={{ border: "1px solid #1a5276", padding: "8px", background: `#e5dfec` }}>Action</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {formData.rate?.map((item, index) => (
//                     <tr key={index}>
//                       <td style={{ border: "1px solid #1a5276", textAlign: "center" }}>{index + 1}</td>

//                       <td style={{ border: "1px solid #1a5276" }}>
//                         <input
//                           className='input'
//                           type="text"
//                           value={item.description}
//                           placeholder="Enter description"
//                           onChange={(e) => handleRateChange(index, "description", e.target.value)}
//                         />
//                       </td>

//                       <td style={{ border: "1px solid #1a5276" }}>
//                         <input
//                           className='input'
//                           type="number"
//                           value={item.amount}
//                           placeholder="Enter amount"
//                           onChange={(e) => handleRateChange(index, "amount", e.target.value)}
//                         />
//                       </td>
//                       <td style={{ border: "1px solid #1a5276" }}>
//                         {index === 0 ? (
//                           <button type="button" className="viewbutton" onClick={addRateRow}>
//                             <AddwithWhiteCircle /> Row
//                           </button>
//                         ) : (
//                           <button
//                             type="button"
//                             className="viewbutton"
//                             onClick={() => removeRateRow(index)}

//                           >
//                             <CrosswithWITECircle /> Remove
//                           </button>)}
//                       </td>


//                     </tr>
//                   ))}



//                   {/* Total Row */}

//                 </tbody>
//               </table>
//             )}





//           </div>
//         </Modal.Body>
//         <div className="button-models-gap-116 " >
//           <div className="">

//             <button type="button" onClick={handleClose} className="cancelbutton">Cancel</button>
//           </div>

//           <div className="">
//             <button class="submitaddbutton" onClick={handleSubmit} type='submit'>
//               <span class="text">Update</span>
//               <span class="icon">
//                 <svg
//                   viewBox="0 0 24 24"
//                   height="24"
//                   width="24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z">
//                   </path>
//                 </svg>
//               </span>
//             </button>

//           </div>

//         </div>

//         <p className="error-message font-size-text margin-top40px">
//           {isSubmitted && Object.keys(errors).length > 0 && (
//             Object.keys(errors).length > 3 ? (
//               <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
//             ) : (
//               Object.keys(errors).map((field) =>
//                 field.charAt(0).toUpperCase() + field.slice(1)
//               ).join(', ') + ' are required!'
//             )
//           )}
//         </p>
//       </Modal>
//     </>
//   );
// };

// const DeletQuotation = ({ i, getData }) => {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const handleFormSubmitDelete = async (e) => {
//     e.preventDefault();
//     const loadingToastId = toast.loading("Loading: Please wait...");

//     try {
//       let res = await axios.delete(
//         `${BASE_URL3}/project/quotations/${i.id}/`
//       );

//       if (res.status === 200) {
//         await getData();
//         setShow(false);
//       } else {
//         alert(res);
//       }
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       toast.dismiss(loadingToastId);
//     }
//   };

//   return (
//     <>
//       <button
//         title="Delete Quotation"
//         className="model-delete-button"
//         onClick={handleShow}
//       >
//         <DeleteDustbin />
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Quotation</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are You Sure, You want to Delete Quotation "{i.ref_no}"
//           <div className="button-models">
//             <button
//               onClick={handleFormSubmitDelete}
//               className="model-button model-button-delete"
//             >
//               Delete
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// UpdateQuotations: drop-in replacement for the old UpdateQuotations (same props, same edit button),
// now with the same UI and theme as AddQuatatations.
// Usage is unchanged: <UpdateQuotations i={row} getNotes={...} worktypeName={...} getData={...} />
// Imports needed (same as AddQuatatations + useRef): React, { useState, useEffect, useMemo, useRef }

// Stable key for a list of selected work types, used to detect real work type changes
const worktypeKey = (list) =>
  (list || []).map((w) => w.id).sort().join(',');

// Turns a saved quotation (API object) into the form shape used by the modal
const buildFormFromQuotation = (q, worktypeList) => {
  const base = getInitialQuotationForm();
  const tables = q.structured_field || [];

  // Work types come from the saved proposal tables (usedfor) and from the saved notes
  const fromTables = tables
    .map((s) => (worktypeList || []).find((w) => w.title === s.usedfor))
    .filter(Boolean)
    .map((w) => ({ id: w.id, name: w.title }));
  const fromNotes = (q.notes || [])
    .map((n) => n.worktype)
    .filter((w) => w && w.id)
    .map((w) => ({ id: w.id, name: w.title ?? w.name }));
  const worktype = [...fromTables, ...fromNotes].filter(
    (w, i, arr) => arr.findIndex((x) => x.id === w.id) === i
  );

  return {
    ...base,
    ...q,
    id: q.id,
    ref_no: q.ref_no ?? '',
    date: q.date ?? '',
    to: q.to && typeof q.to === 'object' ? q.to.id : (q.to ?? ''),
    subject: q.subject ?? '',
    project_details: q.project_details ?? '',
    worktype,
    notes: q.notes || [],
    note_ids: (q.notes || []).map((n) => n.id).filter(Boolean),
    termsandconditions: q.termsandconditions?.length ? q.termsandconditions : base.termsandconditions,
    workstages: q.workstages || base.workstages,
    rate: q.rate?.length ? q.rate : base.rate,
    structured_field: tables.length ? tables : base.structured_field,
    subcompany_id: q.subcompany?.id ?? base.subcompany_id,
  };
};

const UpdateQuotations = ({ getNotes, worktypeName, getData, i: quotation, bankList, authorityList }) => {
  const [formData, setFormData] = useState(getInitialQuotationForm());

  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedTables, setExpandedTables] = useState({});
  const [activeSection, setActiveSection] = useState('basic');
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});
  const [approved, setApproved] = useState(false);
  const [company, setCompany] = useState([]);
  const [subcompany, setSubCompany] = useState([]);
  const [clientData, setClientData] = useState([]);

  // Work type selection the notes were last synced for (stops saved notes being overwritten)
  const syncedWorktypeKey = useRef(null);

  // Load the saved quotation into the form every time the modal opens
  useEffect(() => {
    if (!show || !quotation) return;
    const f = buildFormFromQuotation(quotation, worktypeName);
    syncedWorktypeKey.current = worktypeKey(f.worktype);
    setFormData(f);
    setExpandedTables(
      Object.fromEntries((quotation.structured_field || []).map((s) => [s.usedfor, true]))
    );
    setActiveSection('basic');
    setErrors({});
    setInputState({});
    setTabValidationAttempted({});
    setApproved(false);
  }, [show, quotation?.id, (worktypeName || []).length]);

  // Load companies (bank details for the slip) when the modal opens
  useEffect(() => {
    if (show) getCompany();
  }, [show]);

  /* ===================== TABS CONFIG ===================== */
  const sections = [
    { id: 'basic', label: 'Basic Info', icon: Info, color: '#3b82f6' },
    { id: 'work', label: 'Work Type & Notes', icon: Briefcase, color: '#8b5cf6' },
    { id: 'proposal', label: 'Detailed Proposal', icon: Table2, color: '#f59e0b' },
    { id: 'terms', label: 'Payment Terms', icon: ReceiptText, color: '#10b981' },
    { id: 'preview', label: 'Preview & Approve', icon: Eye, color: '#ef4444' },
  ];

  const tabRequiredFields = {
    basic: ['ref_no', 'date', 'to', 'subject', 'project_details'],
    work: ['worktype'],
    proposal: [],
    terms: [],
    preview: [],
  };

  const fieldLabels = {
    ref_no: 'Ref. Number',
    date: 'Date',
    to: 'Client Name',
    subject: 'Subject',
    project_details: 'Project Details',
    worktype: 'Work Type',
  };

  const isFilled = (field) =>
    field === 'worktype'
      ? formData.worktype?.some((w) => w.id)
      : !!formData[field];

  const getRequiredFields = (tab) => tabRequiredFields[tab] || [];
  const isSectionComplete = (tabId) => getRequiredFields(tabId).every(isFilled);

  const sectionProgress = Math.round(
    ((sections.filter((s) => getRequiredFields(s.id).length > 0 && isSectionComplete(s.id)).length +
      (approved ? 1 : 0)) /
      (sections.filter((s) => getRequiredFields(s.id).length > 0).length + 1)) *
    100
  );

  /* ===================== API ===================== */
  const getSubCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const getCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
      setCompany(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const company_name = sessionStorage.getItem('sub_company_name');
  const subcompanyId = subcompany.filter((i) => i.title === company_name);
  const company_id = subcompanyId.length > 0 ? subcompanyId[0].id : null;
  const companyids = sessionStorage.getItem('sub_company_id');

  const getClientData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL3}/project/clientbysubcompany/${companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? 'null' : '85bc33a1-3a08-4f72-bedc-a3710d246239'}/`
      );
      if (companyids === "025d0b52-e892-4868-a3bb-6b70dcdffb4d") {
        setClientData(res.data.filter((i) => i.sub_company !== "85bc33a1-3a08-4f72-bedc-a3710d246239"));
      } else {
        setClientData(res.data);
      }
    } catch (err) {
      if (err.response) {
        const errorData = err.response.data;
        if (typeof errorData.error === 'string') {
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach((message) => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    }
  };

  useEffect(() => { getSubCompany(); }, []);
  useEffect(() => { getClientData(); }, [company_id]);

  // Reset approval as soon as the user leaves the preview tab
  useEffect(() => {
    if (activeSection !== 'preview') setApproved(false);
  }, [activeSection]);

  /* ===================== NOTES (remove only, directly in formData) ===================== */
  // Flat rows built from formData.notes, so what you see is exactly what is in formData
  const visibleNotes = (formData.notes || []).flatMap((note, noteIndex) =>
    (note.data || []).map((d, lineIndex) => ({
      key: `${noteIndex}-${lineIndex}`,
      noteIndex,
      lineIndex,
      text: d.description,
    }))
  );

  // Notes of the selected work types as they come from the API (used for Restore)
  const originalNotes = (getNotes || []).filter((note) =>
    (formData.worktype || []).some((wt) => wt.id === note.worktype?.id)
  );
  const countLines = (list) => list.reduce((sum, n) => sum + (n.data || []).length, 0);
  const notesWereRemoved = countLines(originalNotes) > visibleNotes.length;

  // Remove one line from formData.notes; drop the whole note (and its id) when no lines are left
  const removeNote = (row) => {
    setFormData((prev) => {
      const notes = (prev.notes || [])
        .map((n, i) =>
          i === row.noteIndex
            ? { ...n, data: (n.data || []).filter((_, li) => li !== row.lineIndex) }
            : n
        )
        .filter((n) => (n.data || []).length > 0);
      return { ...prev, notes, note_ids: notes.map((n) => n.id).filter(Boolean) };
    });
  };

  const restoreNotes = () => {
    setFormData((prev) => ({
      ...prev,
      notes: originalNotes,
      note_ids: originalNotes.map((n) => n.id),
    }));
  };

  // Same font style and size as the NOTE section of the quotation slip
  const quotationNoteTextStyle = {
    fontFamily: 'Arial, sans-serif',
    fontSize: '15px',
    lineHeight: 1.5,
    textAlign: 'justify',
    color: 'black',
  };

  /* ===================== MODAL ===================== */
  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
    setFormData(getInitialQuotationForm());
    setErrors({});
    setInputState({});
    setTabValidationAttempted({});
    setExpandedTables({});
    setApproved(false);
    setActiveSection('basic');
  };

  /* ===================== SELECT OPTIONS ===================== */
  const ClientListData = (clientData || [])
    .filter((i) => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({ value: i.id, label: `${index + 1}. ${i.title}` }));

  const workTypeDatra = (worktypeName || [])
    .filter((i) => i.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((i, index) => ({ value: i.id, label: `${index + 1}. ${i.title}` }));

  const handleClientChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, to_detail: selectedOption ? selectedOption.value : "" }));
    if (selectedOption) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u.to_detail;
        return u;
      });
    }
  };

  const handleWorkTypeChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      worktype: selectedOptions
        ? selectedOptions.map((option) => ({
          id: option.value,
          name: option.label.replace(/^\d+\.\s/, ''),
        }))
        : [],
    }));
    if (selectedOptions && selectedOptions.length) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u.worktype;
        return u;
      });
    }
  };

  /* ===================== EFFECTS (same logic) ===================== */
  useEffect(() => {
    setFormData((prev) => {
      if (!prev.termsandconditions || prev.termsandconditions.length === 0) return prev;
      const workstages = prev.termsandconditions.map((tc) => {
        const match = tc.item.match(/^(\d+)%\s*(.*)$/);
        return {
          percentage: match ? parseFloat(match[1]) : 0,
          workStages: match ? match[2].trim() : "",
        };
      });
      return { ...prev, workstages };
    });
  }, [formData.termsandconditions]);

  useEffect(() => {
    // Wait until the saved quotation has been loaded into the form
    if (!show || !quotation || formData.id !== quotation.id) return;
    const key = worktypeKey(formData.worktype);
    // Same work types as before: keep the saved notes (and the user's removals)
    if (key === syncedWorktypeKey.current) return;
    syncedWorktypeKey.current = key;

    const filteredNotes = (getNotes || []).filter((note) =>
      (formData.worktype || []).some((wt) => wt.id === note.worktype?.id)
    );
    const notesId = filteredNotes.map((i) => i.id);
    setFormData((prev) => ({ ...prev, notes: filteredNotes, note_ids: notesId }));
  }, [getNotes, formData.worktype, show]);

  useEffect(() => {
    if (!formData.worktype || formData.worktype.length === 0) return;
    setFormData((prev) => {
      const newFields = formData.worktype.map((wt) => {
        const existing = prev.structured_field.find((sf) => sf.usedfor === wt.name);
        return (
          existing || {
            usedfor: wt.name,
            Data: [{ heading: "", Data: [{ item: "" }] }],
          }
        );
      });
      return { ...prev, structured_field: newFields };
    });
  }, [formData.worktype]);

  /* ===================== HELPERS: rows / totals ===================== */
  const generateRows = (structuredField) => {
    const maxLength = Math.max(...structuredField.Data.map((h) => h.Data.length));
    return Array.from({ length: maxLength }, (_, rowIndex) =>
      structuredField.Data.map((headingObj) => headingObj.Data[rowIndex] || { item: "" })
    );
  };

  const computeTotal = (sf) => {
    const sum = generateRows(sf).reduce((acc, row) => {
      const lastCell = row[row.length - 1]?.item;
      return acc + (parseFloat(lastCell) || 0);
    }, 0);
    return sum + (parseFloat(sf.worktype_rate) || 0);
  };

  // Submit and Preview both use this same payload (same data = same slip)
  const buildPayload = () => ({
    ...formData,
    structured_field: (formData.structured_field || [])
      .filter((sf) => expandedTables[sf.usedfor])
      .map((sf) => ({ ...sf, total: computeTotal(sf) })),
  });

  const previewData = useMemo(() => {
    if (activeSection !== 'preview') return null;
    const payload = buildPayload();
    const client = (clientData || []).find((c) => c.id === formData.to);
    return {
      ...payload,
      id: 'preview',
      // `to` stays the client id; the readable client name goes into `to_detail`
      to_detail: client?.client_name || client?.title || "",
      subcompany: (company || []).find((c) => c.id === formData.subcompany_id) || {},
    };
  }, [activeSection, formData, expandedTables, clientData, company]);

  /* ===================== VALIDATION + NAV ===================== */
  const getTabErrors = (tab) => {
    const e = {};
    getRequiredFields(tab).forEach((f) => {
      if (!isFilled(f)) e[f] = `${fieldLabels[f] || f} is required!`;
    });
    return e;
  };

  const scrollBodyTop = () => {
    const c = document.querySelector('.modern-modal-body');
    if (c) c.scrollTop = 0;
  };

  const validateCurrentTab = () => {
    const e = getTabErrors(activeSection);
    setErrors((prev) => ({ ...prev, ...e }));
    setTabValidationAttempted((prev) => ({ ...prev, [activeSection]: true }));
    return Object.keys(e).length === 0;
  };

  const validateForm = () => {
    let all = {};
    sections.forEach((s) => { all = { ...all, ...getTabErrors(s.id) }; });
    setErrors(all);
    const firstBad = sections.find((s) => Object.keys(getTabErrors(s.id)).length > 0);
    if (firstBad) {
      setActiveSection(firstBad.id);
      setTabValidationAttempted((prev) => ({ ...prev, [firstBad.id]: true }));
      scrollBodyTop();
    }
    return Object.keys(all).length === 0;
  };

  const goToNextTab = () => {
    const idx = sections.findIndex((s) => s.id === activeSection);
    if (!validateCurrentTab()) { scrollBodyTop(); return; }
    if (sections[idx + 1]) {
      setErrors({});
      setActiveSection(sections[idx + 1].id);
      scrollBodyTop();
    }
  };

  const goToPreviousTab = () => {
    const idx = sections.findIndex((s) => s.id === activeSection);
    if (idx > 0) {
      setActiveSection(sections[idx - 1].id);
      setErrors({});
    }
  };

  const hasCurrentTabErrors = () => getRequiredFields(activeSection).some((f) => errors[f]);

  const getCurrentTabErrorMessage = () => {
    const missing = getRequiredFields(activeSection)
      .filter((f) => !isFilled(f))
      .map((f) => fieldLabels[f] || f);
    if (!missing.length) return null;
    return missing.length === 1
      ? `${missing[0]} is required to proceed`
      : `${missing.length} fields required: ${missing.join(', ')}`;
  };

  const bankingOptions = (bankList || []).map((b) => ({
    value: b.id,
    label: `${b.bank_name} - ${b.branch} (${b.account_no})`,
  }));

  // authority ka naam backend me `bank_name` field me hai
  const authorityOptions = (authorityList || []).map((a) => ({
    value: a.id,
    label: `${a.bank_name} - ${a.designation}`,
  }));

  const handleIdSelectChange = (name) => (selected) => {
    setFormData((prev) => ({ ...prev, [name]: selected ? selected.value : "" }));
    if (selected) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u[name];
        return u;
      });
    }
  };

  /* ===================== SUBMIT ===================== */
  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (!validateForm()) return;
    if (!approved) {
      toast.error("Please approve the preview first.");
      return;
    }

    const loadingToastId = toast.loading("Loading: Please wait...");
    setLoading(true);
    try {
      const res = await axios.put(`${BASE_URL3}/project/quotations/${quotation.id}/`, buildPayload());
      if (res.status === 200 || res.status === 201) {
        getData();
        handleClose();
        toast.dismiss(loadingToastId);
        toast.success("Quotation Details Updated successfully!");
      } else {
        alert(res);
      }
    } catch (err) {
      if (err.response) {
        toast.dismiss(loadingToastId);
        const errorData = err.response.data;
        if (typeof errorData.error === 'string') {
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach((message) => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (activeSection !== 'preview') { goToNextTab(); return; }
    // On the Preview tab, Enter does not submit; only the footer button does
  };

  /* ===================== FIELD HANDLERS ===================== */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState((prev) => ({ ...prev, [name]: value }));
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (value.trim()) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u[name];
        return u;
      });
    }
  };

  const addNewDescription = () => {
    setFormData((prev) => ({
      ...prev,
      termsandconditions: [...prev.termsandconditions, { item: "" }],
    }));
  };

  const handleDescriptionChange = (index, value) => {
    setFormData((prev) => ({
      ...prev,
      termsandconditions: prev.termsandconditions.map((t, i) => (i === index ? { ...t, item: value } : t)),
    }));
    if (value.trim()) {
      setErrors((prev) => {
        const u = { ...prev };
        delete u[`item_${index}`];
        return u;
      });
    }
  };

  const removeDescription = (index) => {
    setFormData((prev) => ({
      ...prev,
      termsandconditions: prev.termsandconditions.filter((_, i) => i !== index),
    }));
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[`item_${index}`];
      const reordered = {};
      Object.keys(updatedErrors).forEach((key) => {
        if (key.startsWith("item_")) {
          const idx = parseInt(key.split("_")[1], 10);
          reordered[`item_${idx > index ? idx - 1 : idx}`] = updatedErrors[key];
        } else {
          reordered[key] = updatedErrors[key];
        }
      });
      return reordered;
    });
  };

  const handleWorkTypeRateChange = (usedfor, value) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor ? { ...sf, worktype_rate: value } : sf
      ),
    }));
  };

  const toggleTable = (usedfor) => {
    setExpandedTables((prev) => {
      const isOpen = prev[usedfor];
      if (isOpen) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          structured_field: prevFormData.structured_field.map((sf) =>
            sf.usedfor === usedfor
              ? {
                ...sf,
                Data: [{ heading: "", Data: [{ item: "" }] }],
                worktype_rate: "",
                total: 0,
              }
              : sf
          ),
        }));
        return { ...prev, [usedfor]: false };
      }
      return { ...prev, [usedfor]: true };
    });
  };

  console.log("formData ", formData)

  /* ===================== FINAL RATE TABLE ===================== */
  const addRateRow = () => {
    setFormData((prev) => ({ ...prev, rate: [...prev.rate, { description: "", amount: "" }] }));
  };

  const removeRateRow = (index) => {
    setFormData((prev) => ({ ...prev, rate: prev.rate.filter((_, i) => i !== index) }));
  };

  const handleRateChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      rate: prev.rate.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    }));
  };

  /* ===================== STRUCTURED FIELD ===================== */
  const handleStructuredFieldChange = (usedfor, headingIndex, itemIndex, value) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) => {
        if (sf.usedfor !== usedfor) return sf;
        const updatedData = sf.Data.map((headingObj, hIdx) => {
          if (hIdx !== headingIndex) return headingObj;
          const updatedItems = [...(headingObj.Data || [])];
          while (updatedItems.length <= itemIndex) updatedItems.push({ item: "" });
          updatedItems[itemIndex] = { item: value };
          return { ...headingObj, Data: updatedItems };
        });
        return { ...sf, Data: updatedData };
      }),
    }));
  };

  const addNewHeading = (usedfor) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? { ...sf, Data: [...sf.Data, { heading: "", Data: [{ item: "" }] }] }
          : sf
      ),
    }));
  };

  const handleHeadingChange = (usedfor, headingIndex, value) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? {
            ...sf,
            Data: sf.Data.map((hdg, idx) => (idx === headingIndex ? { ...hdg, heading: value } : hdg)),
          }
          : sf
      ),
    }));
  };

  const addNewItemToAllHeadings = (usedfor) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? {
            ...sf,
            Data: sf.Data.map((headingObj) => ({
              ...headingObj,
              Data: [...headingObj.Data, { item: "" }],
            })),
          }
          : sf
      ),
    }));
  };

  const handleRemoveRow = (usedfor, rowIndex) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((sf) =>
        sf.usedfor === usedfor
          ? {
            ...sf,
            Data: sf.Data.map((col) => ({
              ...col,
              Data: (col.Data || []).filter((_, idx) => idx !== rowIndex),
            })),
          }
          : sf
      ),
    }));
  };

  const removeColumn = (usedfor, headingIndex) => {
    setFormData((prev) => ({
      ...prev,
      structured_field: prev.structured_field.map((field) =>
        field.usedfor === usedfor
          ? { ...field, Data: field.Data.filter((_, index) => index !== headingIndex) }
          : field
      ),
    }));
  };

  /* ===================== RENDER HELPERS ===================== */
  const renderNavButtons = (showPrev, nextLabel = 'Next') => (
    <div className="section-navigation-buttons dual-buttons">
      <div className="nav-buttons-wrapper">
        {showPrev && (
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
        )}
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          {nextLabel} <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  /* ================= BASIC ================= */
  const renderBasic = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Info} color="#3b82f6" />
        <div>
          <h4>Basic Information</h4>
          <p className="section-subtitle">Reference, client and subject of the quotation</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-field">
          <label><FileText size={14} /> Ref. Number<span className="required">*</span></label>
          <input
            type="text"
            name="ref_no"
            value={formData.ref_no}
            placeholder="e.g. ABCD/EFG/2025-26/456"
            onChange={handleInputChange}
            className={errors.ref_no ? 'error' : inputState.ref_no ? 'success' : ''}
          />
          {errors.ref_no && <span className="error-message"><AlertCircle size={12} /> {errors.ref_no}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Date<span className="required">*</span></label>
          <input
            type="date"
            name="date"
            value={formData.date || ""}
            onChange={handleInputChange}
            className={errors.date ? 'error' : inputState.date ? 'success' : ''}
          />
          {errors.date && <span className="error-message"><AlertCircle size={12} /> {errors.date}</span>}
        </div>

        <div className="form-field full-width">
          <label><Building2 size={14} /> Client Name<span className="required">*</span></label>
          <input
            type="text"
            name="to"
            value={formData.to || ""}
            placeholder="Enter client name"
            onChange={handleInputChange}
            className={errors.to ? 'error' : inputState.to ? 'success' : ''}
          />
          {errors.to && <span className="error-message"><AlertCircle size={12} /> {errors.to}</span>}
        </div>

        {/* <div className="form-field">
          <label><Landmark size={14} /> Banking Detail</label>
          <Select
            options={bankingOptions}
            value={bankingOptions.find((o) => o.value === formData.banking_details) || null}
            onChange={handleIdSelectChange('banking_details')}
            placeholder="Select Banking Detail"
            isClearable
            isSearchable
            noOptionsMessage={() => "No banking details found"}
            styles={CSSForSelectModern}
          />
          {errors.banking_detail && <span className="error-message"><AlertCircle size={12} /> {errors.banking_detail}</span>}
        </div>

        <div className="form-field">
          <label><UserRound size={14} /> Authority Detail</label>
          <Select
            options={authorityOptions}
            value={authorityOptions.find((o) => o.value === formData.authority_details) || null}
            onChange={handleIdSelectChange('authority_details')}
            placeholder="Select Authority Detail"
            isClearable
            isSearchable
            noOptionsMessage={() => "No authority details found"}
            styles={CSSForSelectModern}
          />
          {errors.authority_detail && <span className="error-message"><AlertCircle size={12} /> {errors.authority_detail}</span>}
        </div> */}

        <div className="form-field">
          <label><FileText size={14} /> Subject<span className="required">*</span></label>
          <textarea
            name="subject"
            rows={3}
            value={formData.subject}
            placeholder="e.g. Quotation for Consultancy Services"
            onChange={handleInputChange}
            className={errors.subject ? 'error' : inputState.subject ? 'success' : ''}
          />
          {errors.subject && <span className="error-message"><AlertCircle size={12} /> {errors.subject}</span>}
        </div>

        <div className="form-field">
          <label><FileText size={14} /> Project Details<span className="required">*</span></label>
          <textarea
            name="project_details"
            rows={3}
            value={formData.project_details}
            placeholder="e.g. Corporate HQ"
            onChange={handleInputChange}
            className={errors.project_details ? 'error' : inputState.project_details ? 'success' : ''}
          />
          {errors.project_details && <span className="error-message"><AlertCircle size={12} /> {errors.project_details}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          Next: Work Type & Notes <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  /* ================= WORK TYPE & NOTES ================= */
  const renderWork = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Briefcase} color="#8b5cf6" />
        <div>
          <h4>Work Type & Notes</h4>
          <p className="section-subtitle">Notes load automatically based on the work type; you can remove the ones you do not need</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-field full-width">
          <label><Briefcase size={14} /> Work Type<span className="required">*</span></label>
          <Select
            options={workTypeDatra}
            onChange={handleWorkTypeChange}
            value={workTypeDatra.filter((o) => formData.worktype.some((wt) => wt.id === o.value))}
            placeholder="Select Work Types"
            isClearable
            isSearchable
            isMulti
            inputValue={searchTerm}
            onInputChange={(input) => setSearchTerm(input)}
            noOptionsMessage={() => "No other options"}
            styles={CSSForSelectModern}
          />
          {errors.worktype && <span className="error-message"><AlertCircle size={12} /> {errors.worktype}</span>}
        </div>

        <div className="form-field full-width">
          {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <label style={{ margin: 0 }}>Notes</label>
            {notesWereRemoved && (
              <button type="button" className="btn-add-remark" onClick={restoreNotes}>
                Restore removed notes
              </button>
            )}
          </div> */}

          {visibleNotes.length > 0 ? (
            <div className="remark-table-wrapper" style={{ maxHeight: 320 }}>
              <table className="remark-table">
                <thead>
                  <tr>
                    <th style={{ width: 60 }}>S.No.</th>
                    <th>Notes Description</th>
                    {/* <th style={{ width: 90 }}>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {visibleNotes.map((note, index) => (
                    <tr key={note.key}>
                      <td style={quotationNoteTextStyle}>{index + 1}.</td>
                      <td className="remark-text" style={quotationNoteTextStyle}>
                        {note.text}
                      </td>
                      {/* <td>
                        <button
                          type="button"
                          className="remark-delete"
                          title="Remove note"
                          onClick={() => removeNote(note)}
                        >
                          <Trash2 size={15} />
                        </button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="remark-empty">
              <p>No notes found</p>
              <small>Select a work type to load its notes</small>
            </div>
          )}
        </div>
      </div>

      {renderNavButtons(true)}
    </div>
  );

  /* ================= DETAILED PROPOSAL (+ FINAL AMOUNT TABLE) ================= */
  const renderProposal = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Table2} color="#f59e0b" />
        <div>
          <h4>Detailed Proposal</h4>
          <p className="section-subtitle">Proposal table for each work type and the final amount table</p>
        </div>
      </div>

      {formData.worktype?.length > 0 ? (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
            {formData.structured_field?.map((i) => (
              <button
                key={i.usedfor}
                type="button"
                className="btn-add-remark"
                onClick={() => toggleTable(i.usedfor)}
              >
                {expandedTables[i.usedfor] ? (
                  <><MinusCircle size={16} /> Hide {i.usedfor}</>
                ) : (
                  <><Plus size={16} /> Add {i.usedfor} Proposal</>
                )}
              </button>
            ))}
          </div>

          {formData.structured_field?.map((i, index) =>
            expandedTables[i.usedfor] ? (
              <div className="form-subsection" key={i.usedfor}>
                <h5 className="subsection-title">
                  ({index + 1}). Detailed Proposal of {i.usedfor}
                </h5>
                <div className="remark-table-wrapper" style={{ maxHeight: 'none' }}>
                  <table className="remark-table quote-table">
                    <thead>
                      <tr>
                        <th style={{ width: 50 }}>S.No.</th>
                        {i.Data.map((headingObj, headingIndex) => (
                          <th key={headingIndex}>
                            <div className="quote-th-wrap">
                              <input
                                type="text"
                                className="quote-cell-input"
                                value={headingObj.heading}
                                placeholder="Enter heading"
                                onChange={(e) => handleHeadingChange(i.usedfor, headingIndex, e.target.value)}
                              />
                              <button
                                type="button"
                                className="remark-delete"
                                title="Remove column"
                                onClick={() => removeColumn(i.usedfor, headingIndex)}
                              >
                                <X size={14} />
                              </button>
                            </div>
                          </th>
                        ))}
                        <th style={{ width: 120 }}>
                          <button type="button" className="btn-add-remark" onClick={() => addNewHeading(i.usedfor)}>
                            <Plus size={14} /> Heading
                          </button>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {generateRows(i).map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          <td>{rowIndex + 1}</td>
                          {row.map((cell, cellIndex) => (
                            <td key={cellIndex}>
                              <input
                                type="text"
                                className="quote-cell-input"
                                value={cell.item}
                                placeholder="Enter item"
                                onChange={(e) =>
                                  handleStructuredFieldChange(i.usedfor, cellIndex, rowIndex, e.target.value)
                                }
                              />
                            </td>
                          ))}
                          <td>
                            {rowIndex === 0 ? (
                              <button type="button" className="btn-add-remark" onClick={() => addNewItemToAllHeadings(i.usedfor)}>
                                <Plus size={14} /> Row
                              </button>
                            ) : (
                              <button type="button" className="remark-delete" title="Remove row" onClick={() => handleRemoveRow(i.usedfor, rowIndex)}>
                                <Trash2 size={15} />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}

                      <tr className="quote-total-row">
                        <td></td>
                        <td colSpan={generateRows(i)[0]?.length - 1 || 1} style={{ textAlign: 'right', fontWeight: 600 }}>
                          {i.usedfor}
                        </td>
                        <td>
                          <input
                            type="number"
                            className="quote-cell-input"
                            value={i.worktype_rate || ""}
                            placeholder="Enter work type rate"
                            onChange={(e) => handleWorkTypeRateChange(i.usedfor, e.target.value)}
                          />
                        </td>
                        <td></td>
                      </tr>

                      <tr className="quote-total-row">
                        <td></td>
                        <td colSpan={generateRows(i)[0]?.length - 1 || 1} style={{ textAlign: 'right', fontWeight: 700 }}>
                          Total:
                        </td>
                        <td style={{ fontWeight: 700 }}>{computeTotal(i).toFixed(2)}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null
          )}

          {/* Final amount table */}
          <div className="form-subsection">
            <h5 className="subsection-title">Final Amount Table</h5>
            <div className="remark-table-wrapper" style={{ maxHeight: 'none' }}>
              <table className="remark-table quote-table">
                <thead>
                  <tr>
                    <th style={{ width: 60 }}>S.No.</th>
                    <th>Description</th>
                    <th style={{ width: 200 }}>Amount</th>
                    <th style={{ width: 110 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.rate?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          className="quote-cell-input"
                          type="text"
                          value={item.description}
                          placeholder="Enter description"
                          onChange={(e) => handleRateChange(index, "description", e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="quote-cell-input"
                          type="number"
                          value={item.amount}
                          placeholder="Enter amount"
                          onChange={(e) => handleRateChange(index, "amount", e.target.value)}
                        />
                      </td>
                      <td>
                        {index === 0 ? (
                          <button type="button" className="btn-add-remark" onClick={addRateRow}>
                            <Plus size={14} /> Row
                          </button>
                        ) : (
                          <button type="button" className="remark-delete" title="Remove row" onClick={() => removeRateRow(index)}>
                            <Trash2 size={15} />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div className="remark-empty">
          <p>Please select a Work Type first</p>
          <small>You can add the proposal after choosing a work type in the Work Type & Notes tab</small>
        </div>
      )}

      {renderNavButtons(true)}
    </div>
  );

  /* ================= PAYMENT TERMS ================= */
  const renderTerms = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={ReceiptText} color="#10b981" />
        <div>
          <h4>Payment Terms</h4>
          <p className="section-subtitle">Payment terms and conditions</p>
        </div>
      </div>

      <div className="form-subsection">
        <h5 className="subsection-title">Payment Terms and Conditions</h5>
        <div className="form-grid">
          {formData.termsandconditions?.map((item, index) => (
            <div className="form-field full-width" key={index}>
              <label style={{ justifyContent: 'space-between' }}>
                <span>({index + 1}). Payment Term<span className="required">*</span></span>
                {formData.termsandconditions.length > 1 && (
                  <button type="button" className="remark-delete" title="Remove" onClick={() => removeDescription(index)}>
                    <Trash2 size={15} />
                  </button>
                )}
              </label>
              <input
                type="text"
                name={`item_${index}`}
                value={item.item}
                placeholder="e.g. 50% payment as ABC work"
                onChange={(e) => handleDescriptionChange(index, e.target.value)}
                className={errors[`item_${index}`] ? 'error' : ''}
              />
              {errors[`item_${index}`] && (
                <span className="error-message"><AlertCircle size={12} /> {errors[`item_${index}`]}</span>
              )}
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
          <button type="button" className="btn-add-remark" onClick={addNewDescription}>
            <Plus size={16} /> More Conditions
          </button>
        </div>
      </div>

      {renderNavButtons(true, 'Next: Preview')}
    </div>
  );

  /* ================= PREVIEW & APPROVE ================= */
  const renderPreview = () => (
    <div className="form-section animate-fade-in">
      <div className="section-title">
        <SectionIcon icon={Eye} color="#ef4444" />
        <div>
          <h4>Preview & Approve</h4>
          <p className="section-subtitle">Review the slip; the changes can only be saved after you approve it</p>
        </div>
      </div>

      <div className={`preview-approve-banner ${approved ? 'approved' : ''}`}>
        {approved ? <Check size={16} /> : <AlertCircle size={16} />}
        <span>
          {approved
            ? "Preview approved. You can now click Update Quotation."
            : "Please review the slip below carefully. If everything is correct, click Approve Preview."}
        </span>
      </div>

      <div className="quote-preview-wrap">
        {/* hideNotesEditor: notes are edited in the Work Type & Notes tab */}
        {previewData && <QuotationManagement previewData={previewData} hideNotesEditor />}
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
        </div>
      </div>
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'basic': return renderBasic();
      case 'work': return renderWork();
      case 'proposal': return renderProposal();
      case 'terms': return renderTerms();
      case 'preview': return renderPreview();
      default: return renderBasic();
    }
  };

  /* ===================== RETURN ===================== */
  return (
    <>
      <UpdateModalButton title="Update Quotations" onClick={handleShow} />


      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div className="header-icon-wrapper"><FileText size={24} /></div>
            <div>
              <Modal.Title>Update Quotation Details</Modal.Title>
              <p className="header-subtitle">Edit the details, preview the slip and approve to save the changes</p>
            </div>
          </div>
          <button type="button" className="close-btn" onClick={handleClose}><X size={20} /></button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          {/* Progress */}
          <div className="clean-progress-wrap">
            <div className="clean-progress-info">
              <span className="clean-progress-label">Progress</span>
              <span className="clean-progress-percent">{sectionProgress}%</span>
            </div>
            <div className="clean-progress-bar">
              <div className="clean-progress-fill" style={{ width: `${sectionProgress}%` }} />
            </div>
          </div>

          {/* Tabs */}
          <div className="section-navigation">
            {sections.map((section, index) => {
              const Icon = section.icon;
              const isComplete = isSectionComplete(section.id) && getRequiredFields(section.id).length > 0;
              const hasMissing = getRequiredFields(section.id).some((f) => !isFilled(f));
              const isActive = activeSection === section.id;
              return (
                <React.Fragment key={section.id}>
                  <button
                    type="button"
                    className={`section-nav-btn ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''} ${hasMissing && !isActive && tabValidationAttempted[section.id] ? 'has-warning' : ''}`}
                    style={{ "--section-color": section.color }}
                    onClick={() => {
                      if (activeSection === section.id) return;
                      if (validateCurrentTab()) {
                        setActiveSection(section.id);
                        setErrors({});
                      } else {
                        scrollBodyTop();
                      }
                    }}
                  >
                    <div className="nav-icon-wrap">
                      {isComplete && !isActive ? <Check size={14} /> : <Icon size={15} />}
                    </div>
                    <span>{section.label}</span>
                    {isActive && <ChevronRight size={14} className="nav-arrow" />}
                  </button>
                  {index < sections.length - 1 && <div className="nav-divider" />}
                </React.Fragment>
              );
            })}
          </div>

          <form onSubmit={handleFormSubmit} className="project-form">
            {renderCurrentSection()}
          </form>
        </Modal.Body>

        {activeSection === 'preview' && (
          <Modal.Footer className="modern-modal-footer">
            <button type="button" className="btn-prev" onClick={goToPreviousTab}>
              <ChevronRight size={16} className="rotate-left" /> Previous
            </button>
            <div className="submit-buttons">
              <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
              <button
                type="button"
                className="btn-secondaryy"
                onClick={() => setApproved((p) => !p)}
              >
                <Check size={16} /> {approved ? 'Approved (click to undo)' : 'Approve Preview'}
              </button>
              <button
                type="button"
                className="btn-primaryy"
                disabled={loading || !approved}
                onClick={handleSubmit}
                title={!approved ? "Please approve the preview first" : ""}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                <span>{loading ? 'Updating...' : 'Update Quotation'}</span>
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const DeletQuotation = ({ i, getData }) => {
  const [show, setShow] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");
    setDeleting(true);
    try {
      let res = await axios.delete(`${BASE_URL3}/project/quotations/${i.id}/`);
      if (res.status === 200 || res.status === 204) {
        await getData();
        setShow(false);
        toast.success("Quotation deleted successfully!");
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setDeleting(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <DeleteModalButton title="Delete Quotation" onClick={handleShow} />

      <Modal show={show} onHide={handleClose} centered dialogClassName="request-leave modern-project-modal">
        <Modal.Header closeButton closeVariant="white" className="clean-modal-header delete-modal-header">
          <Modal.Title>Delete Quotation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modern-modal-body">
          <div className="delete-confirm-wrap">
            <div className="delete-warning-icon">
              <DeleteDustbin />
            </div>
            <h5 className="delete-confirm-title">Are you sure?</h5>
            <p className="delete-confirm-subtitle">
              Ye quotation permanently delete ho jayegi.
            </p>

            <div className="delete-preview-card">
              <div className="delete-preview-content">
                <div className="delete-preview-name">
                  <span className="delete-preview-code">{i.ref_no}</span>
                </div>
                <div className="delete-preview-meta">
                  {i?.to?.client_name && <span className="delete-preview-chip">{i.to.client_name}</span>}
                  {i?.project_details && <span className="delete-preview-chip">{i.project_details}</span>}
                </div>
              </div>
            </div>

            <div className="delete-warning-note">This action cannot be undone.</div>
          </div>
        </Modal.Body>
        <div className="clean-modal-footer" style={{ justifyContent: "flex-end" }}>
          <div className="submit-buttons">
            <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
            <button type="button" className="btn-danger-delete" onClick={handleFormSubmitDelete} disabled={deleting}>
              <DeleteDustbin /> Delete
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

// const QuatationDietails = ({ worktypeName, quatationData, notesData, getData, buffer }) => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);



//   };

//   const navigate = useNavigate()

//   const currentUrl = window.location.href;


//   const urlParts = currentUrl.split('/');

//   const baseUrl2 = "/" + urlParts[3] + `/quotationSlip`;
//   const quotationPage = (id) => {
//     const newUrl = baseUrl2 + `/${id}/`;
//     window.open(newUrl, "_blank");
//   }

//   const handleBack = (e) => {
//     navigate(-1);
//   };



//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       <div >
//         <div className="attendance-box">
//           <div className="datagrid-container">
//             <div className="custom-table-background" style={{ height: "66vh" }}>
//               <div className="">
//                 <div className="">
//                   <div className="table-box ">
//                     <div className="flex-row table-heading" style={{ justifyContent: "end" }}>

//                       <AddQuatatations worktypeName={worktypeName} getNotes={notesData} getData={getData} />
//                     </div>
//                   </div>
//                   <div className='table-box scroll-container-table'
//                   >
//                     <table className="table-css width-100vw">
//                       <thead className="table-heading">
//                         <tr className="custom-table-head-tr">
//                           <th className="table-heading ">S.no.</th>
//                           <th className="table-heading text-left">Ref. No.</th>
//                           <th className="table-heading text-left">Project Details</th>
//                           <th className="table-heading text-left">Client</th>
//                           <th className="table-heading text-left" style={{ paddingLeft: "10px" }}>View Quatation</th>
//                           <th className="table-heading text-center">Action</th>
//                         </tr>
//                       </thead>
//                       {buffer ? (

//                         <div className="spinner-bgdatil"></div>

//                       ) :
//                         <tbody>
//                           {
//                             quatationData
//                               .map((i, index) => (
//                                 <tr key={index} className="custom-table-head-td">
//                                   <td>{index + 1}.</td>
//                                   <td>{i.ref_no}</td>
//                                   <td>{i.project_details}</td>
//                                   <td>{i?.to?.client_name}</td>
//                                   <td>
//                                     <button className="eyebutton" onClick={(e) => quotationPage(i.id)}>view</button>

//                                   </td>
//                                   <td>
//                                     <div className='flex-row justify-center'>

//                                       <UpdateQuotations i={i} worktypeName={worktypeName} getNotes={notesData} getData={getData} />
//                                       <DeletQuotation i={i} getData={getData} />
//                                     </div>
//                                   </td>
//                                 </tr>
//                               ))
//                           }
//                         </tbody>
//                       }
//                     </table>

//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// };


const QuatationDietails = ({ authorityList, bankList, worktypeName, quatationData, notesData, getData, buffer }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const baseUrl2 = "/" + urlParts[3] + `/quotationSlip`;

  const quotationPage = (id) => {
    window.open(baseUrl2 + `/${id}/`, "_blank");
  };

  // `to` ab text hai; purani quotations me object (client_name) ho sakta hai
  const getClientName = (q) =>
    typeof q?.to === "string" ? q.to : q?.to?.client_name || q?.to_detail || "";

  const q = searchQuery.trim().toLowerCase();
  const filteredData = (quatationData || []).filter((i) => {
    if (!q) return true;
    return [i.ref_no, i.project_details, getClientName(i)].some((v) =>
      (v || "").toLowerCase().includes(q)
    );
  });

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="wt-page">
        <div className="wt-card">
          {/* ===== HEADER ===== */}
          <div className="wt-header">
            <div className="wt-header-left">
              <div className="wt-header-icon">
                <FileText size={20} />
              </div>
              <div>
                <h4 className="wt-title">
                  Quotations
                  <span className="wt-count">
                    {searchQuery ? `${filteredData.length} / ${(quatationData || []).length}` : (quatationData || []).length}
                  </span>
                </h4>
                <p className="wt-subtitle">Create, edit and view client quotations</p>
              </div>
            </div>

            <div className="wt-header-right">
              <div className="wt-search">
                <Search size={16} />
                <input
                  type="text"
                  placeholder="Search ref no, project, client..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button
                    type="button"
                    className="wt-search-clear"
                    onClick={() => setSearchQuery("")}
                    title="Clear"
                  >
                    <X size={14} />
                  </button>
                )}
              </div>
              <AddQuatatations worktypeName={worktypeName} getNotes={notesData} getData={getData} />
            </div>
          </div>

          {/* ===== TABLE ===== */}
          <div className="wt-table-wrap">
            <table className="wt-table">
              <thead>
                <tr>
                  <th style={{ width: 70 }}>S.No.</th>
                  <th style={{ width: 220 }}>Ref. No.</th>
                  <th>Project Details</th>
                  <th style={{ width: 220 }}>Client</th>
                  <th style={{ width: 120 }}>Quotation</th>
                  <th style={{ width: 140 }} className="wt-th-end">Action</th>
                </tr>
              </thead>

              <tbody>
                {buffer ? (
                  <tr>
                    <td colSpan={6}>
                      <div className="wt-state">
                        <div className="spinner-bgdatil"></div>
                      </div>
                    </td>
                  </tr>
                ) : filteredData.length === 0 ? (
                  <tr>
                    <td colSpan={6}>
                      <div className="wt-state">
                        <FileText size={30} />
                        <p>{searchQuery ? "No matching quotations" : "No quotations found"}</p>
                        <small>
                          {searchQuery
                            ? "Try a different search term"
                            : "Click the add button to create your first quotation"}
                        </small>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredData.map((i, index) => (
                    <tr key={i.id || index}>
                      <td className="wt-sno">{index + 1}.</td>
                      <td>
                        <span className="wt-chip">{i.ref_no || "-"}</span>
                      </td>
                      <td className="wt-clamp" title={i.project_details}>
                        {i.project_details || "-"}
                      </td>
                      <td className="wt-name">{getClientName(i) || "-"}</td>
                      <td>
                        <button
                          type="button"
                          className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075", width: "5vw ", color: "white" }}
                          onClick={() => quotationPage(i.id)}
                        >
                          <Eye size={14} /> View
                        </button>
                      </td>
                      <td>
                        <div className="wt-actions">
                          <UpdateQuotations
                            i={i}
                            worktypeName={worktypeName}
                            getNotes={notesData}
                            getData={getData}
                            bankList={bankList}
                            authorityList={authorityList}
                          />
                          <DeletQuotation i={i} getData={getData} />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div >
    </>
  );
};
export default QuatationDietails;